/*global window, document, dataLayer, jQuery, localStorage, theme*/
var imagePath = 'https://yakima-production.s3.amazonaws.com/fmc/';
var rootPath = window.location.href;
var yakimaApiUrl = 'https://api-eu.yakima.com/api';
var roofTypeIds = [];
var roofTypeNames = [];
var currentSku = '';
var pageLoaded = false;
var fitId = localStorage.getItem('fitId');
var market = 'uk';


var _dcq = _dcq || [];
var _dcs = _dcs || {};
_dcs.account = '3994549';

(function () {
    var dc = document.createElement('script');
    dc.type = 'text/javascript';
    dc.async = true;
    dc.src = '//tag.getdrip.com/3994549.js';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(dc, s);
})();

dataLayer = [{
    'pageCategory': 'FitMyCar'
}];


if (window.location.href.indexOf('localhost') >= 0) {
    yakimaApiUrl = window.location.href.substring(0, window.location.href.lastIndexOf('/')) + '/api';
}

if (rootPath.indexOf('www.yakima.com') >= 0) {
    rootPath = 'https://www.yakima.com';
} else if (rootPath.indexOf('uat') >= 0) {
    yakimaApiUrl = 'https://gost.yakima.com/api/';
    rootPath = 'https://uat1-yakima.robofirm.net/';
}

if(window.location.href.indexOf('fr.yakima') > 0) market = 'fr';
if(window.location.href.indexOf('es.yakima') > 0) market = 'es';
if(window.location.href.indexOf('de.yakima') > 0) market = 'de';
if(window.location.href.indexOf('at.yakima') > 0) market = 'de';
if(window.location.href.indexOf('ch.yakima') > 0) market = 'de';
if(window.location.href.indexOf('it.yakima') > 0) market = 'it';
if(window.location.href.indexOf('cz.yakima') > 0) market = 'cz';
if(window.location.href.indexOf('dk.yakima') > 0) market = 'dk';
if(window.location.href.indexOf('be.yakima') > 0) market = 'be';
if(window.location.href.indexOf('nl.yakima') > 0) market = 'dk';
if(window.location.href.indexOf('no.yakima') > 0) market = 'no';
if(window.location.href.indexOf('pl.yakima') > 0) market = 'pl';
if(window.location.href.indexOf('sk.yakima') > 0) market = 'sk';
if(window.location.href.indexOf('se.yakima') > 0) market = 'se';
if(window.location.href.indexOf('be.yakima.com/fr') > 0) market = 'fr';


jQuery(document).ready(function ($) {
    'use strict';
  jQuery('html').addClass('market' + market);
      

    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();
        e.preventDefault();
    });

    if (window.location.href.indexOf('modal=1') > 0) {
        fmcModalInit();
    }

    if (jQuery('body').hasClass('catalog-product-view') || jQuery('body').hasClass('template-product')) {
        currentSku = jQuery('.sku').first().text().replace('SKU: #', '');


        if (currentSku.length > 0) {
            fitCheck();

            jQuery('.product-options .cs-select').bind("change", function (e) {
                currentSku = jQuery('.sku').first().text().replace('SKU: #', '');
                if (rootPath.indexOf('jetstream') >= 0 && jQuery(this).closest('dd.last').length() == 0) {
                    console.log('Here we go');
                }
                fitCheck();
            });

        }
    }
    if (jQuery('body').hasClass('template-collection')) {
      console.log('template collection');
      setTimeout(function() {
        categoryPage();
        }, 2500);
    }
    if (window.location.href.indexOf('/windshield') > 0) {
        windshieldPage();
    }
 
    cartPopup();
    setFMCVehicle();
    
 if (window.location.href.indexOf('/pages/fit-my-car') > 0) {
        fmcPage();
    }
  if (window.location.href.indexOf('/pages/fit-detail') > 0) {
        fmcDetailPage();
    }

  
    pageLoaded = true;
});



window.addEventListener('searchspring.yakima.domReady',  e =>  categoryPage());


function getTellUs() {
  var txt = "<h3>Tell us about your vehicle.</h3><p>Please Enter Your Vehicle Year, Make and Model<br/>That way we can give you the best fit for your vehicle. </p>";
  if(market == 'fr') txt = "<h3>Parlez-nous de votre véhicule.</h3> <p>Veuillez saisir l'année, la marque et le modèle de votre véhicule. De cette façon, nous pouvons vous proposer la meilleure solution pour votre véhicule.</p>";
  if(market == 'es') txt = "<h3>Háblenos de su vehículo.</h3> <p>Introduzca el año, la marca y el modelo de su vehículo. De esta forma, podemos ofrecerle la mejor opción para su vehículo.</p>";
  if(market == 'de') txt = "<h3>Erzählen Sie uns von Ihrem Fahrzeug.</h3> <p>Bitte geben Sie Ihr Fahrzeugjahr, Ihre Marke und Ihr Modell ein, damit wir Ihnen die beste Lösung für Ihr Fahrzeug bieten können.</p>";
  if(market == 'it') txt = "<h3>Parlaci del tuo veicolo.</h3> <p>Inserisci l'anno, la marca e il modello del tuo veicolo in questo modo possiamo darti la soluzione migliore per il tuo veicolo.</p>";
  if(market == 'cz') txt = "<h3>Řekněte nám něco o vašem vozidle.</h3> <p>Zadejte prosím rok svého vozidla, Značku a model Tímto způsobem vám můžeme poskytnout to nejlepší pro vaše vozidlo.</p>";
  if(market == 'dk') txt = "<h3>Vertel ons over uw voertuig.</h3> <p>Voer het jaar, merk en model van uw voertuig in Op die manier kunnen we u de beste pasvorm voor uw voertuig geven.</p>";
  if(market == 'no') txt = "<h3>Fortell oss om kjøretøyet ditt</h3> <p>Vennligst skriv inn kjøretøyåret ditt, Merke og modell På den måten kan vi gi deg den beste passformen for kjøretøyet ditt.</p>";
  if(market == 'pl') txt = "<h3>Opowiedz nam o swoim pojeździe.</h3> <p>Wprowadź rok pojazdu, markę i model W ten sposób możemy zapewnić Ci najlepsze dopasowanie do Twojego pojazdu.</p>";
  if(market == 'sk') txt = "<h3>Povedzte nám o vašom vozidle.</h3> <p>Zadajte rok, značku a model vášho vozidla Tým to spôsobom vám môžeme poskytnúť čo najlepšie vyhovovať vášmu vozidlu.</p>";
  if(market == 'se') txt = "<h3>Berätta om ditt fordon.</h3> <p>Ange ditt fordonsår, Märke och modell På så sätt kan vi ge dig den bästa passformen för ditt fordon.</p>";
  if(market == 'be') txt = "<h3>Vertel ons over uw voertuig.</h3> <p>Voer het jaar, merk en model van uw voertuig in zodat we u de beste pasvorm voor uw voertuig kunnen geven.</p> "
  return txt;
}
function getStep2() {
  var txt = "<h3>What does your vehicle roof look like?</h3><pThe roof of the vehicle determines the roof rack.</p>";
  if(market == 'fr') txt = "<h3>À quoi ressemble le toit de votre véhicule ?</h3> <p>Le toit du véhicule détermine la galerie de toit.</p>";
  if(market == 'es') txt = "<h3>¿Qué aspecto tiene el techo de su vehículo?</h3> <p>El techo del vehículo determina el portaequipajes.</p>";
  if(market == 'de') txt = "<h3>Wie sieht Ihr Fahrzeugdach aus?</h3> <p>Das Dach des Fahrzeugs bestimmt den Dachträger.</p>";
  if(market == 'it') txt = "<h3>Che aspetto ha il tetto del tuo veicolo?</h3> <p>Il tetto del veicolo determina il portapacchi.</p>";
  if(market == 'cz') txt = "<h3>Jak vypadá střecha vašeho vozidla?</h3> <p>Střecha vozidla určuje střešní nosič.</p>";
  if(market == 'dk') txt = "<h3>Hoe ziet het dak van uw auto eruit?</h3> <p>Het dak van het voertuig bepaalt het imperiaal op het dak.</p>";
  if(market == 'no') txt = "<h3>Hvordan ser kjøretøyets tak ut?</h3> <p>Taket på kjøretøyet bestemmer takstativet.</p>";
  if(market == 'pl') txt = "<h3>Jak wygląda dach Twojego pojazdu?</h3> <p>Dach pojazdu określa bagażnik dachowy.</p>";
  if(market == 'sk') txt = "<h3>Ako vyzerá strecha vášho vozidla?</h3> <p>Strecha vozidla určuje strešný nosič.</p>";
  if(market == 'se') txt = "<h3>Hur ser ditt biltak ut?</h3> <p>Fordonets tak bestämmer takräcket.</p>";
  if(market == 'be') txt = "<h3>Hoe ziet uw dak eruit?</h3> <p>Het dak van het voertuig bepaalt het imperiaal op het dak.</p>";
  return txt;
}
function getStepTruck() {
    var txt = "What does your truck bed look like?";
  if(market == 'fr') txt = "À quoi ressemble la caisse de votre camion ?";
  if(market == 'es') txt = "¿Qué aspecto tiene la plataforma de tu camioneta?";
  if(market == 'de') txt = "Wie sieht deine Ladefläche aus?";
  if(market == 'it') txt = "Che aspetto ha il pianale del tuo camion?";
  if(market == 'cz') txt = "Jak vypadá vaše náklaďák?";
  if(market == 'dk') txt = "Hoe ziet je vrachtwagenbed eruit?";
  if(market == 'no') txt = "Hvordan ser lastebilsengen din ut?";
  if(market == 'pl') txt = "Jak wygląda twoje łóżko ciężarówki?";
  if(market == 'sk') txt = "Ako vyzerá vaša posteľ nákladného vozidla?";
  if(market == 'se') txt = "Hur ser din lastbilssäng ut?";
  if(market == 'be') txt = "Hoe ziet uw laadbak er uit ?";
  return txt;
}
function getStep3() {
  var txt = "<h3>What kind of crossbars does you roof rack have?</h3><p>Please complete the section to move on to the next step.</p>";
  if(market == 'fr') txt = "<h3>Quel type de barres transversales possède votre galerie de toit ?</h3> <p>Veuillez compléter la section pour passer à l'étape suivante.</p>";
  if(market == 'es') txt = "<h3>¿Qué tipo de travesaños tiene tu portaequipajes?</h3> <p>Complete la sección para continuar con el siguiente paso.</p>";
  if(market == 'de') txt = "<h3>Was für Querträger hat Ihr Dachträger?</h3> <p>Bitte füllen Sie den Abschnitt aus, um mit dem nächsten Schritt fortzufahren.</p>";
  if(market == 'it') txt = "<h3>Che tipo di traverse ha il tuo portapacchi?</h3> <p>Completa la sezione per passare alla fase successiva.</p>";
  if(market == 'cz') txt = "<h3>Jaké příčky máte střešní nosič?</h3> <p>Chcete-li přejít k dalšímu kroku, vyplňte sekci.</p>";
  if(market == 'dk') txt = "<h3>Wat voor soort dwarsbalken heeft uw imperiaal?</h3> <p>Vul het gedeelte in om door te gaan naar de volgende stap.</p>";
  if(market == 'no') txt = "<h3>Hva slags tverrstenger har du takstativ?</h3> <p>Vennligst fyll ut delen for å gå videre til neste trinn.</p>";
  if(market == 'pl') txt = "<h3>Jakie poprzeczki ma bagażnik dachowy?</h3> <p>Wypełnij sekcję, aby przejść do następnego kroku.</p>";
  if(market == 'sk') txt = "<h3>Aký druh priečnikov máte strešný nosič?</h3> <p>Ak chcete prejsť na ďalší krok, vyplňte časť.</p>";
  if(market == 'se') txt = "<h3>Vilken typ av tvärstänger har ditt takräcke?</h3> <p>Fyll i avsnittet för att gå vidare till nästa steg.</p>";
  if(market == 'be') txt = "<h3>Wat voor soort dwarsbalken heeft uw imperiaal?</h3> <p>Vul het gedeelte in om door te gaan naar de volgende stap.</p>";
  return txt;
}
function getStep4() {
  var txt = "<h3 class='center vcenter'>Great! Let\'s roll.</h3><p class='center'>Now you can search for products that fit to your vehicle type. Click Save below to begin your search.</p>";
  if(market == 'fr') txt = "<h3 class='center vcenter'>Super ! Allons-y.</h3> <p class='center'>Vous pouvez maintenant rechercher des produits adaptés à votre type de véhicule. Cliquez sur Enregistrer ci-dessous pour lancer votre recherche.</p>";
  if(market == 'es') txt = "<h3 class='center vcenter'>¡Genial! Vamos a rodar.</h3> <p class='center'>Ahora puedes buscar productos que se ajusten a tu tipo de vehículo. Haz clic en Guardar a continuación para comenzar la búsqueda.</p>";
  if(market == 'de') txt = "<h3 class='center vcenter'>Großartig! Lass uns loslegen.</h3> <p class='center'>Jetzt können Sie nach Produkten suchen, die zu Ihrem Fahrzeugtyp passen. Klicken Sie unten auf Speichern, um mit der Suche zu beginnen.</p>";
  if(market == 'it') txt = "<h3 class='center vcenter'>Ottimo! Andiamo.</h3> <p class='center'>Ora puoi cercare i prodotti adatti al tuo tipo di veicolo. Fai clic su Salva qui sotto per iniziare la ricerca.</p>";
  if(market == 'cz') txt = "<h3 class='center vcenter'>Skvělé! Pojďme se hýbat.</h3> <p class='center'>Nyní můžete vyhledávat produkty, které odpovídají vašemu typu vozidla. Kliknutím na tlačítko Uložit níže zahájíte vyhledávání.</p>";
  if(market == 'dk') txt = "<h3 class='center vcenter'>Geweldig! Laten we gaan.</h3> <p class='center'>Nu kunt u zoeken naar producten die passen bij uw voertuigtype. Klik hieronder op Opslaan om te beginnen met zoeken.</p>";
  if(market == 'no') txt = "<h3 class='center vcenter'>Flott! La oss rulle.</h3> <p class='center'>Nå kan du søke etter produkter som passer til kjøretøytypen din. Klikk Lagre nedenfor for å starte søket.</p>";
  if(market == 'pl') txt = "<h3 class='center vcenter'>Świetnie! Rzućmy się.</h3> <p class='center'>Teraz możesz wyszukiwać produkty pasujące do Twojego typu pojazdu. Kliknij Zapisz poniżej, aby rozpocząć wyszukiwanie.</p>";
  if(market == 'sk') txt = "<h3 class='center vcenter'>Skvelé! Poďme sa prevrátiť.</h3> <p class='center'>Teraz môžete vyhľadávať produkty, ktoré zodpovedajú vášmu typu vozidla. Kliknutím na položku Uložiť nižšie spustíte vyhľadávanie.</p>";
  if(market == 'se') txt = "<h3 class='center vcenter'>Jättebra! Låt oss rulla.</h3> <p class='center'>Nu kan du söka efter produkter som passar din fordonstyp. Klicka på Spara nedan för att börja din sökning.</p>";
   if(market == 'be') txt = "<h3 class='center vcenter'>Geweldig! Laten we gaan.</h3> <p class='center'>Nu kunt u zoeken naar producten die passen bij uw voertuigtype. Klik hieronder op Opslaan om te beginnen met zoeken.</p>";
return txt;
}

function getWhatSystem() {
  var txt = "What rack system?";
  if(market == 'fr') txt = "Quel système de rack ?";
  if(market == 'es') txt = "¿Qué sistema de estanterías?";
  if(market == 'de') txt = "Welches Racksystem?";
  if(market == 'it') txt = "Quale sistema di rack?";
  if(market == 'cz') txt = "Jaký stojanový systém?";
  if(market == 'dk') txt = "Welk racksysteem?";
  if(market == 'no') txt = "Hvilket racksystem?";
  if(market == 'pl') txt = "Jaki system regałów?";
  if(market == 'sk') txt = "Aký regálový systém?";
  if(market == 'se') txt = "Vilket racksystem?";
  if(market == 'be') txt = "Welk racksysteem?";
  return txt;
}
function getSave() {
  var txt = "Save";
  if(market == 'fr') txt = "Enregistrer";
  if(market == 'es') txt = "Guardar";
  if(market == 'de') txt = "Speichern";
  if(market == 'it') txt = "Salva";
  if(market == 'cz') txt = "Uložit";
  if(market == 'dk') txt = "Opslaan";
  if(market == 'no') txt = "Lagre";
  if(market == 'pl') txt = "Zapisz";
  if(market == 'sk') txt = "Uložiť";
  if(market == 'se') txt = "Spara";
  if(market == 'be') txt = "Opslaan";
  return txt;
}
function getRoofRacksFor() {
  var txt = "Roof Racks For";
  if(market == 'fr') txt = "Barres de toit pour";
  if(market == 'es') txt = "Barras de techo para";
  if(market == 'de') txt = "Dachträger für";
  if(market == 'it') txt = "Portapacchi per";
  if(market == 'cz') txt = "Střešní nosiče pro";
  if(market == 'dk') txt = "Dakdragers voor";
  if(market == 'no') txt = "Takstativ til";
  if(market == 'pl') txt = "Bagażniki dachowe dla";
  if(market == 'sk') txt = "Strešné nosiče pre";
  if(market == 'se') txt = "Takräcken för";
  if(market == 'be') txt = "Dakdragers voor";
  return txt;
}
function getThirdParty() {
  var txt = "<h3>Third Party or Custom Rack</h3><p>A system made by one of our competitors</p>";
  if(market == 'fr') txt = "<h3>Étagère tierce ou personnalisée</h3> <p>Un système fabriqué par l'un de nos concurrents</p>";
  if(market == 'es') txt = "<h3>Rack personalizado o de terceros</h3> <p>Un sistema fabricado por uno de nuestros competidores</p>";
  if(market == 'de') txt = "<h3>Drittanbieter- oder kundenspezifisches Rack</h3> <p>A-System, hergestellt von einem unserer Wettbewerber</p>";
  if(market == 'it') txt = "<h3>Rack di terze parti o personalizzato</h3> <p>Un sistema realizzato da uno dei nostri concorrenti</p>";
  if(market == 'cz') txt = "<h3>Systém třetí strany nebo Custom Rack</h3> <p>Systém vyrobený některým z našich konkurentů</p>";
  if(market == 'dk') txt = "<h3>Rack van derden of op maat</h3> <p>Een systeem gemaakt door een van onze concurrenten</p>";
  if(market == 'no') txt = "<h3>Tredjeparts- eller Custom Rack</h3> <p>Et system laget av en av våre konkurrenter</p>";
  if(market == 'pl') txt = "<h3>Third Party lub Custom Rack</h3> <p>System wykonany przez jednego z naszych konkurentów</p>";
  if(market == 'sk') txt = "<h3>Systém tretej strany alebo Custom Rack</h3> <p>Systém vyrobený jedným z našich konkurentov</p>";
  if(market == 'se') txt = "<h3>Tredjeparts- eller Custom Rack</h3> <p>Ett system tillverkat av en av våra konkurrenter</p>";
  if(market == 'be') txt = "<h3>Rack van derden of op maat</h3> <p>Een systeem gemaakt door een van onze concurrenten</p>";
  return txt;
}


function getAddVehicle() {
  var txt = "<span id='label-find'>Find the right products for your vehicle</span><span class='get-started-button yakima-fmc right-arrow-link'>Add Vehicle</span>";
  if(market == 'fr') txt = "<span id='label-find'>Trouvez des produits pour votre véhicule</span> <span class='get-started-button yakima-fmc right-arrow-link'>Choisissez une voiture</span>";
  if(market == 'es') txt = "<span id='label-find'>Encuentra productos para tu vehículo</span> <span class='get-started-button yakima-fmc right-arrow-link'>Elige vehículo</span>";
  if(market == 'de') txt = "<span id='label-find'>Finde die richtigen Produkte für dein Auto</span> <span class='get-started-button yakima-fmc right-arrow-link'>Suche dein Auto</span>";
  if(market == 'it') txt = "<span id='label-find'>Trova i prodotti per il tuo veicolo</span> <span class='get-started-button yakima-fmc right-arrow-link'>Scegli il veicolo</span>";
  if(market == 'cz') txt = "<span id='label-find'>Najděte produkty pro vaše vozidlo</span> <span class='get-started-button yakima-fmc right-arrow-link'>Vyberte Vozidlo</span>";
  if(market == 'dk' || market == 'be') txt = "<span id='label-find'>Vind producten voor mijn voertuig</span> <span class='get-started-button yakima-fmc right-arrow-link'>Kies een voertuig</span>";
  if(market == 'no') txt = "<span id='label-find'>Finn produkter til kjøretøyet ditt</span> <span class='get-started-button yakima-fmc right-arrow-link'>Velg kjøretøy</span>";
  if(market == 'pl') txt = "<span id='label-find'>Znajdź produkty do swojego pojazdu</span> <span class='get-started-button yakima-fmc right-arrow-link'>Wybierz pojazd</span>";
  if(market == 'sk') txt = "<span id='label-find'>Nájdite produkty pre vaše vozidlo</span> <span class='get-started-button yakima-fmc right-arrow-link'>Vyberte si vozidlo</span>";
  if(market == 'se') txt = "<span id='label-find'>Hitta produkter för ditt fordon</span> <span class='get-started-button yakima-fmc right-arrow-link'>Välj fordon</span>";
  return txt;
}
function getRoofType(roofType) {
  var txt = "";
  if(roofType == "My vehicle has crossbars") {
    if(market == 'fr') txt = "Mon véhicule est équipé de barres transversales";
    if(market == 'es') txt = "Mi vehículo tiene travesaños";
    if(market == 'de') txt = "Mein Fahrzeug hat Querträger";
    if(market == 'it') txt = "Il mio veicolo è dotato di barre trasversali";
    if(market == 'cz') txt = "Moje vozidlo má příčky";
    if(market == 'dk') txt = "Mijn auto heeft dwarsbalken";
    if(market == 'no') txt = "Kjøretøyet mitt har tverrstenger";
    if(market == 'pl') txt = "Mój pojazd ma poprzeczki";
    if(market == 'sk') txt = "Moje vozidlo má priečky";
    if(market == 'se') txt = "Mitt fordon har tvärstänger";
    if(market == 'be') txt = "Mijn auto heeft reeds dakdragers";
  }
  if(roofType == "Naked Roof") {
    if(market == 'fr') txt = "Toit vide";
    if(market == 'es') txt = "Techo vacío";
    if(market == 'de') txt = "Leeres Dach";
    if(market == 'it') txt = "Tetto vuoto";
    if(market == 'cz') txt = "Prázdná střecha";
    if(market == 'dk') txt = "Leeg dak";
    if(market == 'no') txt = "Tomt tak";
    if(market == 'pl') txt = "Pusty dach";
    if(market == 'sk') txt = "Prázdna strecha";
    if(market == 'se') txt = "Tomt tak";
    if(market == 'be') txt = "Leeg dak";
  }
  if(roofType == "Raised Siderails") {
    if(market == 'fr') txt = "Rails latéraux surélevés";
    if(market == 'es') txt = "Barandillas elevadas";
    if(market == 'de') txt = "Erhöhte Seitengeländer";
    if(market == 'it') txt = "Sponde laterali rialzate";
    if(market == 'cz') txt = "Vyvýšené sideraily";
    if(market == 'dk') txt = "Verhoogde zijrails";
    if(market == 'no') txt = "Hevede siderails";
    if(market == 'pl') txt = "Podniesione boczniki";
    if(market == 'sk') txt = "Vyvýšené bočné okraje";
    if(market == 'se') txt = "Upphöjda Siderails";
    if(market == 'be') txt = "Open dakrails";
  }
  
  if(roofType == "Flush Siderails") {
    if(market == 'fr') txt = "Rails latéraux Flush";
    if(market == 'es') txt = "Barandas laterales al ras";
    if(market == 'de') txt = "Flush Siderails";
    if(market == 'it') txt = "Sponde laterali a filo";
    if(market == 'cz') txt = "Flush Siderails";
    if(market == 'dk') txt = "Zijrails doorspoelen";
    if(market == 'no') txt = "Flush Siderails";
    if(market == 'pl') txt = "Płukanie boczne";
    if(market == 'sk') txt = "Splachové bočné lišty";
    if(market == 'se') txt = "Flush Siderails";
    if(market == 'be') txt = "Gesloten dakrails";
  }
  if(roofType == "My truck bed is empty") {
    if(market == 'fr') txt = "La caisse de mon camion est vide";
    if(market == 'es') txt = "La caja de mi camioneta está vacía";
    if(market == 'de') txt = "Meine Ladefläche ist leer";
    if(market == 'it') txt = "Il pianale del mio camion è vuoto";
    if(market == 'cz') txt = "Moje postel v kamionu je prázdná";
    if(market == 'dk') txt = "Mijn laadbak is leeg";
    if(market == 'no') txt = "Lastebilsengen min er tom";
    if(market == 'pl') txt = "Moje łóżko ciężarówki jest puste";
    if(market == 'sk') txt = "Posteľ môjho kamiónu je prázdna";
    if(market == 'se') txt = "Min lastbilsbädd är tom";
    if(market == 'be') txt = "Hoe ziet uw laadbed eruit?";
  }
  if(roofType == "I have crossbars across my empty truck bed") {
    if(market == 'fr') txt = "J'ai des barres transversales sur la plate-forme de mon camion";
    if(market == 'es') txt = "Tengo travesaños en la plataforma de mi camioneta";
    if(market == 'de') txt = "Ich habe Querstangen auf meiner Ladefläche";
    if(market == 'it') txt = "Ho delle traverse sul pianale del mio camion";
    if(market == 'cz') txt = "Mám příčky na posteli náklaďáku";
    if(market == 'dk') txt = "Ik heb dwarsbalken op mijn vrachtwagenbed.";
    if(market == 'no') txt = "Jeg har tverrstenger på lastebilsengen min";
    if(market == 'pl') txt = "Mam poprzeczki na łóżku ciężarówki";
    if(market == 'sk') txt = "Na posteli nákladného vozidla mám priečky";
    if(market == 'se') txt = "Jag har tvärstänger på min lastbilssäng";
    if(market == 'be') txt = "Ik heb dakdragers op mijn laadbak";
  }
  if(txt == "") txt = roofType;
  return txt;
}
function getStep5() {
  var txt = "";
  if(window.location.href.indexOf('fr.yakima') > 0) txt = "";
  if(window.location.href.indexOf('es.yakima') > 0) txt = "";
  if(window.location.href.indexOf('de.yakima') > 0) txt = "";
  if(window.location.href.indexOf('it.yakima') > 0) txt = "";
  if(window.location.href.indexOf('cz.yakima') > 0) txt = "";
  if(window.location.href.indexOf('dk.yakima') > 0) txt = "";
  if(window.location.href.indexOf('no.yakima') > 0) txt = "";
  if(window.location.href.indexOf('pl.yakima') > 0) txt = "";
  if(window.location.href.indexOf('sk.yakima') > 0) txt = "";
  if(window.location.href.indexOf('se.yakima') > 0) txt = "";
  return txt;
}
function getYear() {
  var txt = "Year";
  if(market == 'fr') txt = "Année";
  if(market == 'es') txt = "Año";
  if(market == 'de') txt = "Jahr";
  if(market == 'it') txt = "Anno";
  if(market == 'cz') txt = "Rok";
  if(market == 'dk') txt = "Jaar";
  if(market == 'no') txt = "År";
  if(market == 'pl') txt = "Rok";
  if(market == 'sk') txt = "Rok";
  if(market == 'se') txt = "År";
  if(market == 'be') txt = "Jaar";
  return txt;
}
function getMake() {
  var txt = "Make";
  if(market == 'fr') txt = "Marque";
  if(market == 'es') txt = "Marca";
  if(market == 'de') txt = "Marke";
  if(market == 'it') txt = "Marca";
  if(market == 'cz') txt = "Značka";
  if(market == 'dk') txt = "Merk";
  if(market == 'no') txt = "Varemerke";
  if(market == 'pl') txt = "Marka";
  if(market == 'sk') txt = "Značka";
  if(market == 'se') txt = "Varumärke";
  if(market == 'be') txt = "Merk";
  return txt;
}
function getModel() {
  var txt = "Model";
  if(market == 'fr') txt = "Modèle";
  if(market == 'es') txt = "Modelo";
  if(market == 'de') txt = "Modell";
  if(market == 'it') txt = "Modello";
  if(market == 'cz') txt = "Modelka";
  if(market == 'dk') txt = "Model";
  if(market == 'no') txt = "Modell";
  if(market == 'pl') txt = "Model";
  if(market == 'sk') txt = "Model";
  if(market == 'se') txt = "Modell";
  if(market == 'be') txt = "Model";
  return txt;
}
function getType() {
  var txt = "Type";
  if(market == 'fr') txt = "Tapez";
  if(market == 'es') txt = "Tipo";
  if(market == 'de') txt = "Typ";
  if(market == 'it') txt = "Tipo";
  if(market == 'cz') txt = "Typ";
  if(market == 'dk') txt = "Typ";
  if(market == 'no') txt = "Type";
  if(market == 'pl') txt = "Typ";
  if(market == 'sk') txt = "Modell";
  if(market == 'se') txt = "Typ";
  if(market == 'be') txt = "Typ";
  return txt;
}
function getRemove() {
  var txt = "Remove";
  if(market == 'fr') txt = "Supprimer";
  if(market == 'es') txt = "Eliminar";
  if(market == 'de') txt = "Entfernen";
  if(market == 'it') txt = "Rimuovi";
  if(market == 'cz') txt = "Odstranit";
  if(market == 'dk') txt = "Verwijderen";
  if(market == 'no') txt = "Fjerne";
  if(market == 'pl') txt = "Usuń";
  if(market == 'sk') txt = "Odstrániť";
  if(market == 'se') txt = "Ta bort";
  if(market == 'be') txt = "Verwijderen";
  return txt;
}
function fmcModalInit() {
    jQuery('#fmc-modalbackground').show();
    jQuery('#fmc-container').show();
    jQuery('.white-header').css('height', 0);
    jQuery('#fmc-container').html('<div id="fmc-header"><span class="fmc-title">' + getAddVehicle() + '</span><span class="close">X CLOSE</span></div><div id="fmc-step1" class="third"><div class="content"></div></div><div id="fmc-step2" class="third"><div class="content"></div></div><div id="fmc-step3" class="third"><div class="content"></div></div>');

    jQuery('#fmc-step1').append('<div class="fmc-modal-vehicle"><span class="name"></span><a href="">Edit</a><hr/></div>');
    jQuery('#fmc-step1 .content').html(getTellUs() + '<select id="year-selector"></select><select id="make-selector"></select><select id="model-selector"></select><select id="type-selector"></select>');

    jQuery('#fmc-step2').append('<div class="fmc-modal-vehicle"><span class="name"></span><a href="">Edit</a><hr/></div>');
    resetSteps();

    loadYears();
    jQuery('#fmc-container .close').click(function () {
        jQuery('#fmc-container').hide();
        jQuery('#fmc-modalbackground').hide();
        jQuery('.white-header').css('height', 'auto');


    });
    jQuery('.fmc-modal-vehicle a').bind("click tap", function (e) {
        jQuery(this).parent().parent().removeClass('selected');
        e.preventDefault();
    });
}
function clearLocalStorage() {
  
  var partnerId = localStorage.getItem('partnerId');
  var ipCountry = localStorage.getItem('ipCountry');
  var subscribeSeen = localStorage.getItem('subscribe-seen');
  localStorage.clear();
  if (partnerId)
    localStorage.setItem('partnerId', partnerId);
  if (ipCountry)
    localStorage.setItem('ipCountry', ipCountry);
  if (subscribeSeen)
    localStorage.setItem('subscribe-seen', subscribeSeen);
}
function resetSteps() {
    jQuery('#fmc-step2 .content').addClass('blur').html(getStep2() + '<div class="option crossbars"><img src="https://yakima-production.s3.amazonaws.com/fmc/car-hasrack.jpg"><h3>My vehicle has crossbars</h3><p>Crossbars run perpendicular to the roof.</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/naked-roof.jpg"><h3>My vehicle roof is \'naked\'</h3><p>There is nothing on the roof at all.</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/flush-siderails.jpg"><h3>My Vehicle roof has Flush Side Rails.</h3><p>Flush side rails run parrallel to the doors and are flush to the roof surface.</p></div>');
    jQuery('#fmc-step3 .content').addClass('blur').html(getStep3() + '<div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/jetstream.png"><h3>JetStream</h3></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/corebar.png"><h3>CoreBar</h3><p></p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/hdbar.png"><h3>HDBar</h3><p>﻿</p></div><div class="option"><img src="https://yakima-production.s3.amazonaws.com/fmc/roundbar.png"><h3>RoundBar</h3><p></p></div>');

}
function loadYears() {
    jQuery('#year-selector').html(jQuery('<option></option>').attr('value', '').text(getYear()));
    jQuery('#model-selector').addClass('disabled').append(jQuery('<option></option>').attr('value', '').text(getModel()));
    jQuery('#make-selector').addClass('disabled').append(jQuery('<option></option>').attr('value', '').text(getMake()));
    for (year = new Date().getFullYear() + 1; year >= new Date().getFullYear() - 39; year--) {
        $option = jQuery('<option></option>').attr('value', year).text(year);
        jQuery('#year-selector').append($option);
    }
    if (localStorage.getItem('year')) {
        jQuery('#year-selector').val(localStorage.getItem('year'));
        yearSelected(jQuery('#year-selector'));
        jQuery('#make-selector').show().removeClass('disabled');
    }
    jQuery('#year-selector').change(function () {
        jQuery('#make-selector').show().removeClass('disabled');
        jQuery('#fmc-step2').removeClass('selected');
        year = jQuery('#year-selector').val();
       clearLocalStorage();
        resetSteps();
        localStorage.setItem('year', year);
        yearSelected();
        jQuery('#model-selector').html(jQuery('<option></option>').attr('value', '').text(getModel()));

    });
}
function yearSelected(el) {
    year = jQuery('#year-selector').val();

    if (!year) {
        return;
    }
    jQuery('#make-selector').html(jQuery('<option></option>').attr('value', '').text(getMake()));
    url = yakimaApiUrl + '/make/GetMakes/' + year + '/true/true/6';
  console.log(url);
    jQuery.get(url, function (data) {
        if (typeof data == 'object') {
            jQuery('#model-selector').removeClass('disabled');
            jQuery.each(data, function (i, e) {
                var selected = false;
                if (localStorage.getItem('makeId') && e.value == localStorage.getItem('makeId'))
                    selected = true;
                if (typeof e.id !== 'undefined' && typeof e.name !== 'undefined') {
                    $option = jQuery('<option></option>').attr('value', e.id).text(e.name);
                    jQuery('#make-selector').append($option);
                }
            });
        }
        if (localStorage.getItem('makeId')) {
            jQuery('#make-selector').val(localStorage.getItem('makeId'));
            makeSelected(jQuery('#make-selector'));
        //    jQuery('#make-selector').removeClass('disabled');
        }
        jQuery('#make-selector').unbind().change(function () {
            jQuery('#model-selector').show().removeClass('disabled');
            jQuery('#fmc-step2').removeClass('selected');

            year = jQuery('#year-selector').val();
            makeId = jQuery('#make-selector').val();
            makeName = jQuery('#make-selector option:selected').text();
            clearLocalStorage();
            resetSteps();
            localStorage.setItem('year', year);
            localStorage.setItem('makeId', makeId);
            localStorage.setItem('make-name', makeName);
            makeSelected();

        });
    });

    jQuery('#type-selector').hide();
}

function makeSelected() {
    makeId = jQuery('#make-selector').val();
    if (!year || !makeId) {
        return;
    }
    url = yakimaApiUrl + '/model/GetUniqueModels/' + year + '/' + makeId + '/true/true/6';

console.log(url);
    jQuery.get(url, function (data) {
        jQuery('#model-selector').html('');
        if (typeof data == 'object') {
            jQuery('#model-selector').append(jQuery('<option></option>').attr('value', '').text(getModel()));
            jQuery('#make-selector').removeClass('disabled');
            jQuery.each(data, function (i, e) {
                if (typeof e.name !== 'undefined')
                    jQuery('#model-selector').append(jQuery('<option></option>').attr('value', e.id).text(e.name));
            });
        }

        if (localStorage.getItem('vehicleMarketId')) {
            jQuery('#model-selector').val(localStorage.getItem('vehicleMarketId'));
            if(jQuery('#model-selector').val())
                modelSelected();
        }
        jQuery('#model-selector').unbind().change(function () {
            if (jQuery('#model-selector option:selected').text() != localStorage.getItem('model-name')) {
                jQuery('#fmc-step2').removeClass('selected');

                year = jQuery('#year-selector').val();
                makeId = jQuery('#make-selector').val();
                makeName = jQuery('#make-selector option:selected').text();
                clearLocalStorage();
                resetSteps();
                localStorage.setItem('year', year);
                localStorage.setItem('makeId', makeId);
                localStorage.setItem('make-name', makeName);
            //   localStorage.setItem('modelId', jQuery('#model-selector').val());
                localStorage.setItem('vehicleMarketId', jQuery('#model-selector').val());
                localStorage.setItem('model-name', jQuery('#model-selector option:selected').text());
                modelSelected();

            }
        });
        jQuery('#type-selector').hide();
    });
}

function modelSelected() {
    jQuery('#type-selector').html('');
    var model = jQuery('#model-selector option:selected').text();
    var vmId = jQuery('#model-selector').val();
  
    model = model.replaceAll('/', '~');
    if (!year || !makeId) {
        return;
    }
    
    localStorage.setItem('vehicleMarketId', vmId);
    selectVehicle();

}

function selectVehicle() {
    var modelName = jQuery('#model-selector option:selected').text();
    var vmId = jQuery('#model-selector').val();

    localStorage.setItem('model-name', modelName);
    if (modelName.length > 0) {
        jQuery('#fmc-step1 .fmc-modal-vehicle .name').text(localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name'));

    }

    modelName = modelName.replaceAll('/', '~');
    jQuery('#fmc-step2 .content').removeClass('top-selected');
   // var url = yakimaApiUrl + '/vehicle/GetVehicleByModel/' + localStorage.getItem('year') + '/' + localStorage.getItem('makeId') + '/' + encodeURIComponent(modelName)  + '/0/6';
   var url = yakimaApiUrl + '/vehicle/GetVehicleByVM/' + vmId;
  console.log(url);
    jQuery.get(url, function (data) {
        if (typeof data == 'object') {
            localStorage.setItem("isTruck", data[0] != null && data[0].class == 2);
           
                localStorage.setItem("vehicleId", data[0].id);
                loadRoofTypes();
                jQuery('#fmc-step1').addClass('selected');
        }
    });
}

function selectSystem() {

    if (!jQuery('#select-system').hasClass('disabled')) {
        var rooftypeId = localStorage.getItem('rooftypeId');
        var rooftypeStatus = localStorage.getItem('rooftypeStatus');
        var systemPage = jQuery('#shopify-section-system-template').length > 0;
        var productPage = jQuery('body.catalog-product-view').length > 0;
        var towerCat = window.location.href.indexOf('product-type/tower-system') > 0;
        var isTruck = localStorage.getItem('isTruck') ;
        var container = '<div id="fmc-modal-container" class="ajax-success-message modal-container active reversed"><div class="ajax-success-message modal-content"><div class="content">';
        var urlprefix = '';

        if(window.location.href.indexOf('/fr/') > 0)
          urlprefix = '/fr';
      
        dataLayer.push({
            'event': 'cftProgress',
            'step': {
                'name': 'Car Fit Tool - Selected',
                'vpv': '/vpv/car-fit-tool/selected'
            },
            'vehicleData': {
                'make': '' + localStorage.getItem('make-name') + '',
                'model': '' + localStorage.getItem('model-name') + '',
                'year': '' + localStorage.getItem('year') + '',
                'roofType': '' + localStorage.getItem('rooftypeName').replace('My vehicle has ', '') + '',
                'system': '' + localStorage.getItem('system-name') + ''
            }
        });
        var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
        if (localStorage.getItem('vehicle-type'))
            vehName = vehName + ' ' + localStorage.getItem('vehicle-type');
        var roofType = localStorage.getItem('rooftypeName').replace('My vehicle has ', '').replace('I have a ', '').replace('I have ', '');
        if (roofType == 'crossbars') {
            if (localStorage.getItem('system-name') == 'BaseLine' || localStorage.getItem('system-name') == 'QTower' || localStorage.getItem('system-name') == '1A Raingutter' || localStorage.getItem('system-name') == 'Control Tower') {
                roofType = 'naked roof';
                rooftypeId = '1';
            }
            else if (localStorage.getItem('system-name') == 'SkyLine' || localStorage.getItem('system-name') == 'Yakima FlushBar' || localStorage.getItem('system-name') == 'RidgeLine') {
                roofType = 'flush siderails';
                rooftypeId = '12';
            }
            else if (localStorage.getItem('system-name') == 'TimberLine' || localStorage.getItem('system-name') == 'Yakima RailBar' || localStorage.getItem('system-name') == 'RailGrab') {
                roofType = 'raised siderails';
                rooftypeId = '4';
            }

        }

        dataLayer.push({
            'event': 'fmcSelect',
            'fmcVehicle': '' + vehName,
            'fmcRooftype': '' + roofType + '',
            'fmcRooftypeId': '' + rooftypeId + '',
            'fmcVehicleId': '' + localStorage.getItem('vehicleId')
        });

        if (localStorage.getItem('fitId') && parseInt(localStorage.getItem('fitId')) > 0) {
            dataLayer.push({
                'event': 'fmcFitSelect',
                'action': 'existing',
                'fmcFitId': '' + localStorage.getItem('fitId')
            });
          if (window.location.href.indexOf('retailer-fmc') > 0 || window.location.href.indexOf('configurator') > 0) {
            window.location = urlprefix + '/collections/all';
        	}
        }
        console.log('make:' + localStorage.getItem('make-name') + '|model:' + localStorage.getItem('model-name') + '|year:' + localStorage.getItem('year') + '|roofType:' + localStorage.getItem('rooftypeName').replace('My vehicle has ', '') + '|system:' + localStorage.getItem('system-name') + '');

      
        if (rooftypeStatus == '5' && isTruck != 'true')
            jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your vehicle. </p><div class="actions"><a class="button reversed outline" href="https://explore.yakima.com/custom-install">Custom Install Options</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');
        else if ((localStorage.getItem('noRoofFit') == 'true' || rooftypeStatus == '-1') && isTruck != 'true')
            jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your vehicle. </p><div class="actions"><a class="button reversed outline" href="https://explore.yakima.com/custom-install">Custom Install Options</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');
        else if (fitId == -4)
            jQuery('body').first().append(container + '<p><b>For Your Safety we cannot confirm compatibility with non-Yakima Roof Rack Systems.</b><br/>However, you\'re more than welcome to shop and purchase any Yakima products with this in mind.  Our products do fit nearly any crossbar shape - but again, we cannot confirm compatibility and fullfill product and gear warranty with a non-Yakima rack system.</p><div class="actions"><a onclick="reloadPage();" class="button reversed close">I Understand</a></div></div></div>');
        else if (isTruck == 'true' && localStorage.getItem('truckbedId') == '-2')
            jQuery('body').first().append(container + '<p>Unfortunately we do not have a roof rack system that fits your truckcap.</p><div class="actions"><a class="button reversed outline" href="https://explore.yakima.com/custom-install">Custom Install Options</a><a onclick="reloadPage();" class="button reversed close">No Thanks</a></div></div></div>');

        else if (fitId == -2 )
            window.location =  urlprefix + '/pages/fit-my-car';
         else if ((fitId == 0 || fitId == -3) && !systemPage && !towerCat && !productPage) {
           window.location =  urlprefix + '/pages/fit-my-car';
                      
        }
        else if (window.location.href.indexOf('retailer-fmc') > 0 || window.location.href.indexOf('configurator') > 0) {
            window.location = urlprefix + '/collections/all';
        }
        else {
         //   setCurrentFit();
            if (window.location.href.indexOf('stayput') <= 0) {
                if (window.location.href.indexOf('modal') > 0)
                    window.location = window.location.href.replace('?modal=1', '');
                else
                        window.location.reload();

            }
        }
        jQuery('#fmc-container').hide();
        jQuery('#fmc-modalbackground').hide();
        jQuery('.white-header').css('height', 'auto');



    }
}

function reloadPage() {

    if (window.location.href.indexOf('modal') > 0)
        window.location = window.location.href.replace('?modal=1', '');
    else
        window.location.reload();
}
function closeFMCModal() {
    jQuery('#fmc-modal-container').remove();

}
function checkInventory(sku) {
    if (sku && sku.length > 0) {
        var url = yakimaApiUrl + '/inventory/GetInventoryValue?sku=' + sku;
        console.log(url);
        jQuery.get(url, function (data) {
            return parseInt(data);


        });
    }
}
function loadRoofTypes() {
    jQuery('#fmc-step2 .content').removeClass('blur');

    if (localStorage.getItem('isTruck') == 'true') {
        jQuery('#fmc-step2').addClass('scroll');
        jQuery('#fmc-step2 .content').empty().append('' + getStep2() + '<a href="" class="edit-crossbars">Edit</a>');
    }
    else {
        jQuery('#fmc-step2').removeClass('scroll');
        jQuery('#fmc-step2 .content').empty().append(getStep2());
    }
  var model = localStorage.getItem('model-name');
  model = model.replaceAll('/', '~');
    jQuery('#fmc-step2 .content').append('<div class="option toc crossbars" data-id="0"><img src="' + imagePath + 'car-hasrack.jpg"/><h3>' + getRoofType('My vehicle has crossbars') + '</h3></div>');
    url = yakimaApiUrl + '/rooftype/GetRoofTypesByName/' + localStorage.getItem('year') + '/' + localStorage.getItem('makeId') + '/' + encodeURIComponent(model) + '/' + localStorage.getItem('vehicle-type') + '/6/false/true';
    console.log(url);
    roofTypeIds = [];
    roofTypeNames = [];

    jQuery.get(url, function (data) {
        if (typeof data == 'object') {
            var cnt = 0;
            jQuery.each(data, function (i, e) {
                if (typeof e.id !== 'undefined') {
                    var cls = '';
                  //  if (e.Id == 14 && jQuery('#fmc-step2 .content .option.naked-roof').length > 0) {
                        //Hide Naked Roof Fixed Point if Naked Roof exists
                 //   }
                //    else
                        jQuery('#fmc-step2 .content').append('<div class="option toc ' + e.img + cls + '" data-id="' + e.id + '" data-status="' + e.statusId + '"><img src="' + imagePath + e.img + '.jpg"/><h3>' + getRoofType(e.name) + '</h3></div>');
                    roofTypeIds[cnt] = e.id;
                    roofTypeNames[cnt] = e.name;
                    cnt++;
                }
            });
            localStorage.setItem('noRoofFit', cnt == 0);
            if (cnt == 0) {
                jQuery('#fmc-step2 .content').append('<div class="option toc naked-roof" data-id="1"><img src="' + imagePath + 'naked-roof.jpg"/><h3>' + getRoofType('Naked Roof') + '</h3></div>');

            }


            jQuery('#fmc-step2 .content .option.toc').click(function () {
                jQuery('#fmc-step2 .content .option.toc.selected').removeClass('selected');
                jQuery(this).addClass('selected');
                localStorage.setItem('rooftypeId', jQuery(this).attr('data-id'));
                localStorage.setItem('rooftypeName', jQuery(this).find('h3').text());
                localStorage.setItem('rooftypeStatus', jQuery(this).attr('data-status'));

                if (localStorage.getItem('isTruck') !== 'true' || jQuery('#fmc-step2 .content .option.truck.selected').length > 0) {
                    loadTowers();
                    jQuery('#fmc-step2').addClass('selected');
                }
                jQuery('#fmc-step2 .name').text(jQuery(this).find('h3').text());
                jQuery('.truckOptions').removeClass('blur');

            });
            jQuery('#fmc-step2 .content .option').each(function () {
                if (localStorage.getItem('fitId') && localStorage.getItem('fitId') != '0' && jQuery(this).attr('data-id') == '0')
                    jQuery(this).click();
                else if (localStorage.getItem('fitId') == '0' && parseInt(localStorage.getItem('rooftypeId')) == jQuery(this).attr('data-id')) {
                    jQuery(this).click();
                }
            });
            jQuery('#fmc-step2 .content .edit-crossbars').bind("click tap", function (e) {
                jQuery('#fmc-step2 .content').removeClass('top-selected');
                e.preventDefault();
            });
            if (localStorage.getItem('isTruck') == 'true') {
                var cls = ' blur';
                if (jQuery('.option.toc.selected').length > 0)
                    cls = '';
                jQuery('#fmc-step2 .content').append('<hr/>');
                jQuery('#fmc-step2 .content').append('<span class="truckOptions' + cls +'"><h3>' + getStepTruck() + '</h3></span>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck empty" data-id="-1"><img src="' + imagePath + 'truck-norack.jpg"/><h3>' + getRoofType('My truck bed is empty') + '</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck crossbars" data-id="16"><img src="' + imagePath + 'truck-hasrack.jpg"/><h3>' + getRoofType('I have crossbars across my empty truck bed') + '</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck truckcap" data-id="-2"><img src="' + imagePath + 'truck-shell.jpg"/><h3>Truckcap</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck truckcap-bars" data-id="4"><img src="' + imagePath + 'truck-shell-crossbars.jpg"/><h3>Truckcap with roof rack</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck tonneau" data-id="-3"><img src="' + imagePath + 'tonneau.jpg"/><h3>Tonneau cover</h3></div>');
                jQuery('#fmc-step2 .content .truckOptions').append('<div class="option truck tonneau tonneau-bars" data-id="16"><img src="' + imagePath + 'tonneau-crossbars.jpg"/><h3>Tonneau cover with crossbars</h3></div>');
                jQuery('#fmc-step2 .content .select-roof').click(function () {
                    localStorage.setItem('rooftypeId', '0');
                    loadTowers();
                });
                jQuery('#fmc-step2 .content .option.truck').unbind().click(function () {
                    jQuery('#fmc-step2 .content .option.truck.selected').removeClass('selected');
                    jQuery(this).addClass('selected');
                    localStorage.setItem('truckbedId', jQuery(this).attr('data-id'));
                    localStorage.setItem('hasTonneau', jQuery(this).hasClass('tonneau'));
                    if (jQuery('#fmc-step2 .content .option.toc.selected').length > 0) {
                        jQuery('#fmc-step2').addClass('selected');
                        loadTowers();
                    }
                });
            }
        }
    });


}


function loadTowers() {


    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var isTruck = localStorage.getItem('isTruck');


    jQuery('#fmc-step3 .content').removeClass('blur');

    if ((rooftypeId != '0' && isTruck != 'true') || (isTruck && (localStorage.getItem('rooftypeId') == '1' || localStorage.getItem('rooftypeId') == '3' || localStorage.getItem('rooftypeId') == '4')  && (localStorage.getItem('truckbedId') == '-1' || localStorage.getItem('truckbedId') == '-2' || localStorage.getItem('truckbedId') == '-3'))) {
        jQuery('#fmc-step3').removeClass('scroll');
        jQuery('#fmc-step3 .content').empty().append(getStep4());
        jQuery('#fmc-step3 .fmc-save').remove();
        jQuery('#fmc-step3 .content').append('<div class="fmc-save"><button onclick="selectSystem()" id="select-system">' + getSave() + '</button></div>');

        if (localStorage.getItem('truckbedId') == '-2' || localStorage.getItem('truckbedId') == '-3')
            fitId = -3;
        else
            fitId = 0;
        localStorage.setItem('fitId', fitId);
        localStorage.setItem('system-name','');
        localStorage.setItem('crossbarMin','');

    }
    else {

        jQuery('#fmc-step3 .content').empty().append('<h3>' + getWhatSystem() + '</h3>');

        if (isTruck == 'true' && localStorage.getItem('rooftypeId') != '0')
            rooftypeId = '16';
        if(localStorage.getItem('truckbedId') == '4')
            rooftypeId = '4';

        var url = yakimaApiUrl + '/fit/getFits/EU/' + vehicleId + '/' + rooftypeId + '/true/false/false';

        if (isTruck == 'true' && localStorage.getItem('truckbedId') == '16')
            url = url + '&includeTruck=true';
        if (isTruck == 'true' && localStorage.getItem('truckbedId') == '-1')
            url = url + '&excludeRoofType=16';

        var container = "";

        if (isTruck == 'true') {
            jQuery('#fmc-step3 .content').append('<select id="rooftype-selector"><option value="0">Select Mount Location</option></select>');
            jQuery('#fmc-step3 .content select').append('<option value="1">Roof</option>');
            jQuery('#fmc-step3 .content select').append('<option value="16">Truck Bed</option>');
        }
        else if (rooftypeId == 0 && roofTypeIds.length > 1) {
            jQuery('#fmc-step3 .content').append('<select id="rooftype-selector"><option value="0">Showing All</option></select>');
            for (i = 0; i < roofTypeIds.length; i++) {
                jQuery('#fmc-step3 .content select').append('<option value="' + roofTypeIds[i] + '">' + roofTypeNames[i] + '</option>');
            }

        }
        else {
            jQuery('#fmc-step3 .content').append('<div class="select-spacer"></div>');
        }
        jQuery('#fmc-step3 #rooftype-selector').change(function () {
            var rtId = jQuery('#fmc-step3 #rooftype-selector').val();
            jQuery('#fmc-step3 .content .option').show();
            jQuery('#fmc-step3 .content .option').each(function (index) {
                if (rtId != '0' && jQuery(this).attr('data-rooftype') != rtId && jQuery(this).attr('data-rooftype') != -1) {
                    jQuery(this).hide();
                }
            });
        });
      console.log(url);
        jQuery.get(url, function (data) {
            if (typeof data == 'object') {
                var cnt = 0;
                jQuery.each(data, function (i, e) {
                    if (typeof e.id !== 'undefined') {
                        var cls = '';
                        if (fitId == e.id) {
                            cls = ' selected';
                            jQuery('#select-system').removeClass('disabled');
                        }
                        if (localStorage.getItem('hasTonneau') == 'true' && (e.name.toLowerCase().indexOf('outdoorsman') >= 0 || e.name.toLowerCase().indexOf('bedrock') >= 0)) {
                            //Hide Outdoorsman and BedRock if vehicle has Tonneau cover
                        }
                        else {
                            jQuery('#fmc-step3 .content' + container).append('<div class="option' + cls + '" data-id="' + e.id + '" data-rooftype="' + e.roofTypeId + '" data-minlength="' + e.minBarLength + '" data-status="' + e.statusId + '"><img src="' + imagePath + e.name.toLowerCase().replace('yakima ', '').replace(' ', '-') + '.png"/><h3>' + e.name + ' System</h3><p>' + e.shortDesc + '</p></div>');
                            localStorage.removeItem('noRoofFit');
                        }
                    }
                });


                jQuery('#fmc-step3 .content').append('<div class="option thirdparty" data-id="-4" data-rooftype="-1"><img src="' + imagePath + 'third-party.jpg"/>' + getThirdParty() + '</div>');

                if (jQuery('#fmc-step3 .fmc-save').length == 0)
                    jQuery('#fmc-step3').append('<div class="fmc-save"><button onclick="selectSystem()" id="select-system" class="disabled">Save</button></div>');
                else
                    jQuery('#select-system').removeClass('disabled').addClass('disabled');

                if (jQuery('#fmc-step3 .content .option').length > 4)
                    jQuery('#fmc-step3').addClass('scroll');
                else
                    jQuery('#fmc-step3').removeClass('scroll');

                jQuery('#fmc-step3 .content .option').click(function () {
                    fitId = jQuery(this).attr('data-id');
                    localStorage.setItem('fitId', fitId);
                });

                var rtId = jQuery('#fmc-step3 #rooftype-selector').val();


                jQuery('#fmc-step3 .content .option').click(function () {
                    jQuery('#fmc-step3 .content .option.selected').removeClass('selected');
                    jQuery(this).addClass('selected');
                    jQuery('#select-system').removeClass('disabled');
                    localStorage.setItem('fitId', jQuery(this).attr('data-id'));
                //    localStorage.setItem('rooftypeId', jQuery(this).attr('data-rooftype'));
                    var systemName = jQuery('#fmc-step3 .content .option.selected h3').first().text().replace(' System', '');
                    localStorage.setItem('system-name', systemName);
                    localStorage.setItem('crossbarMin', jQuery('#fmc-step3 .content .option.selected').first().attr('data-minlength'));
                });
                jQuery('#fmc-step3 .content .option').each(function () {
                    if (parseInt(localStorage.getItem('fitId')) == jQuery(this).attr('data-id')) {
                        jQuery(this).click();
                    }
                });
            }
        });


    }


}
function setFMCVehicle() {
    if (localStorage.getItem('model-name')) {
        var fmcMsg = '';
        var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
        fmcMsg = '<a id="get_started_button"> ' + vehName;
        if (localStorage.getItem('system-name'))
            fmcMsg += ' with a ' + localStorage.getItem('system-name') + ' system';
        fmcMsg += '</a> <a id="vehicle_remove" class="right-arrow-link" onclick="removeVehicle()"> <span>' + getRemove() + '</span></a>';

        jQuery('#fmc-add-vehicle').html(fmcMsg);
        jQuery('#fmc-page #vehicle-title').html(getRoofRacksFor() + ' '+ vehName);

    }
    else {
        jQuery('#fmc-add-vehicle').html('<a id="get_started_button">' + getAddVehicle() + '</a>');
    }
    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();
        e.preventDefault();
    });
}
function removeVehicle() {
    
  clearLocalStorage();
    fitId = 0;
    jQuery('#fmc-add-vehicle').html('<a id="get_started_button">' + getAddVehicle() + '</a>');
    jQuery('#fitCurrentVehicle').html('<p><span style="color: #CCCCCC;">&#149;</span> Is this product compatible with your vehicle?&nbsp;&nbsp; <a href="#" class="fmc">Add Your Vehicle</a></p>');
    jQuery('#get_started_button').bind("click tap", function (e) {
        fmcModalInit();

        e.preventDefault();
    });
   if (jQuery('body').hasClass('template-collection')) {
        window.location.reload();
    }
    fitCheck();
}

function fitCheck() {
    var productFit = 0;
    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
    var isTent = false;
    var sku = jQuery('.product-single__meta .sku').first().text().replace('SKU: #', '');
    var systemPage = (jQuery('#shopify-section-system-template').length > 0);
    var isLNL = window.location.href.indexOf('locknload') > 0;
    var truckSystem = window.location.href.indexOf('overhaul') > 0 || window.location.href.indexOf('outpost') > 0 || window.location.href.indexOf('bedrock') > 0 || window.location.href.indexOf('outdoorsman') > 0;

    if (localStorage.getItem('systemId') && systemPage)
        fitId = localStorage.getItem('systemId');
  	if(localStorage.getItem('fitId') == '0' && isLNL && localStorage.getItem('towerSystemId'))
      fitId = localStorage.getItem('towerSystemId');

    if (sku == "8007406" || sku == "8007407" || sku == "8007434" || sku == "8007432" || sku == "8007436" || sku == "8007437")
        isTent = true;

    jQuery('.template-product').addClass('nofit');

   // if ((fitId && fitId.length > 0) || (vehicleId && vehicleId.length > 0 && rooftypeId && rooftypeId.length > 0)) {
        if (!fitId || fitId.length == 0)
            fitId = 0;

        if (truckSystem && localStorage.getItem('truckbedId') == '-4') {
            if (isTent)
                setFitMessage('#666', 'We cannot confirm compatibility with your rack system, please read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>.');
            else
                setFitMessage('#666', 'We cannot confirm compatibility with your rack system.');
        }
        else if (truckSystem && localStorage.getItem('hasTonneau') == 'true' && ((window.location.href.indexOf('overhaul-hd-system') < 0 && window.location.href.indexOf('overhaul-hd-tonneau') < 0 && window.location.href.indexOf('outpost-hd-system') < 0) || localStorage.getItem('tonneauType') == 'tonneau-0')) {
            setFitMessage('Red', ' Does not fit your ' + vehName + '.');
        }
        else if (truckSystem && fitId == 0 && localStorage.getItem('truckbedId') == '-3') {
            if (isTent)
                setFitMessage('#666', 'Please contact the manufacturer of your Truck Shell/RV/Camper for their recommendation and options for carrying roof top tents, and read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>.');
            else
                setFitMessage('#666', 'Please contact the manufacturer of your Truck Shell/RV/Camper for their recommendation and options for carrying Yakima products.</p>');
        }
        else if (truckSystem && localStorage.getItem('isTruck') == 'false') {
            setFitMessage('#666', 'This system is designed for truck beds only.');
        }
        else if (truckSystem && localStorage.getItem('truckbedId') == '-2') {
            productFit = 1;
        }
        else if ((vehicleId == null || vehicleId == 0) && isTent) {
            setFitMessage('#666', 'We need more information before confirming vehicle fit. <a href="#" onclick="fmcModalInit();">Continue</a>.');
        }
        else if (fitId == 0 && isTent) {
            setFitMessage('#666', 'We cannot confirm compatibility with your vehicle, please read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>. ');

        }
   		else if (localStorage.getItem('fitId') == '-4')
                        setFitMessage('#666', 'We cannot confirm compatibility with your rack system. ');
        else if (localStorage.getItem('system-name') == 'Factory Rack' && isTent) {
            setFitMessage('Red', ' Does not fit your ' + vehName + '.');
        }

        else {
            if (localStorage.getItem('isTruck') == 'true' && localStorage.getItem('truck-placement') == 'truck-bed')
                rooftypeId = '16';
     //       var url = yakimaApiUrl + '/fitcheck/GetFitCheck/' + fitId + '/' + sku + '/' + vehicleId + '/' + rooftypeId;
       //     console.log(url);
        //    jQuery.get(url, function (data) {
         //       productFit = data > 0;

         //       if (data == 0) {
         //          if (localStorage.getItem('vehicleId')) {
          //              if (isLNL && fitId == 0)
            //                setFitMessage('#666', 'Rack System Required (<a href="/product-type/tower-system">Shop</a>)');
           ///             else if (isLNL && fitId == -4) {
           //                 setFitMessage('#666', 'We cannot confirm compatibility with your vehicle, please read our LockNLoad Vehicle Evaluation Guidelines and Best Practices.');
            //                jQuery('.template-product').removeClass('nofit');
            //            }
           //             else if (systemPage && !isLNL)
            //                setFitMessage('Red', ' Does not fit your ' + vehName + '.  Learn about <a href="https://explore.yakima.com/custom-install">custom install options</a>.');
          //              else
             //               setFitMessage('Red', ' Does not fit your ' + vehName + '. ');
             //       }
             //       else {
              //          setFitMessage('#666', 'We need more information before confirming vehicle fit. <a href="#" onclick="fmcModalInit();">Continue</a>.');
              //      }
             //   }
           //     else if (data == -1) {
          //          if (localStorage.getItem('rooftypeStatus') == '-1') //If this is a CFU or explicit NoFit
          //              setFitMessage('Red', ' Does not fit your ' + vehName + '.  Learn about <a href="https://explore.yakima.com/custom-install">custom install options</a>.');
          //          else if (localStorage.getItem('vehicleId') && fitId == 0)
          //              setFitMessage('#666', 'Rack System Required (<a href="/product-type/tower-system">Shop</a>)');
          //          else if (localStorage.getItem('fitId') == '-4')
          //              setFitMessage('#666', 'We cannot confirm compatibility with your rack system. ');
          //          else
          //              setFitMessage('#666', 'We need more information before confirming vehicle fit. <a href="#" onclick="fmcModalInit();">Continue</a>.');
          //      }
          //      else if (data == -3) {
          //          setFitMessage('#666', 'Ensure the perfect fit on a hitch receiver <a target="_blank" href="http://yakweb-assets.s3.amazonaws.com/Yakima-Hitch-Fit-Tips.pdf">here</a>');

           //     }
         //       else if (data == -5 && isTent)
         //           setFitMessage('#666', 'We cannot confirm compatibility with your rack system, please read our <a href="https://explore.yakima.com/skyrise-rooftop-tent-guidelines-best-practices" target="_blank">SkyRise Vehicle Evaluation Guidelines and Best Practices</a>.');
        //        else if (data == -5 || (isLNL && data == -4)) {
        //            setFitMessage('#666', 'We cannot confirm compatibility with your vehicle, please read our LockNLoad Vehicle Evaluation Guidelines and Best Practices.');
         //           jQuery('.template-product').removeClass('nofit');

          //      }
          //      if (productFit > 0) {
          //          if (data == 1 && fitId == 0 && !systemPage) {
          //              setFitMessage('#666', 'Rack System Required (<a href="/product-type/tower-system">Shop</a>)');

          //          }
          ///          else {

          //              setFitMessage('#64a70b', ' Fits your ' + vehName + '');
          //              if (isLNL)
          //                  jQuery('#attachment-bar .pill').hide();

          //              jQuery('.template-product').removeClass('nofit');
          //              var url = yakimaApiUrl + '/fitnote/GetFitNotes/' + fitId + '/' + currentSku;
         //               jQuery.get(url, function (data) {
         //                   jQuery.each(data, function (i, e) {
         //                       setFitMessage('Yellow', e.note);
         //                   });
         //               });
         //           }

         //       }
        //        if (isLNL && data !== -1) {
        //            var fid = fitId;
        //            if (jQuery('#attachment-tower').hasClass('selected'))
        //                fid = localStorage.getItem('towerSystemId');
        //            jQuery('.tower-platform-size .platform').each(function () {
        //                var platform = jQuery(this);
        //                var dataSku = jQuery(this).attr('data-sku');
        //                var url = yakimaApiUrl + '/fitcheck/GetFitCheck/' + fid + '/' + dataSku + '/' + vehicleId + '/' + rooftypeId;
        //                console.log(url);
        //                jQuery.get(url, function (data) {
        //                    if (data > 0) {
        //                        jQuery(platform).find('.pill').removeClass('yellow').addClass('red').text('Recommended');
        //                    }
        //                });
        //            });
        //        }
         //   });
        }
   // }

}

function setFitMessage(color, content) {
    document.getElementById('fitCurrentVehicle').innerHTML = '<p><span style="color: ' + color + ';">&#149;</span> ' + content + '</p>';

}

function categoryPage() {
    var vehicleId = localStorage.getItem('vehicleId');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var towerCat = window.location.href.indexOf('collections/roof-rack-systems') > 0 || window.location.href.indexOf('collections/truck-rack-systems') > 0;


  //setTimeout(function() {
    if (towerCat) {
        var listClass = 'grid grid--view-items';
      jQuery('#category-nofit').remove();
        jQuery('#shopify-section-collection-template .ss-content-container').first().append('<div id="category-nofit"><h2>Does Not Fit Your Vehicle</h2><ul class="' + listClass + '"></ul></div>');
        jQuery('.main .sidebar').hide();
        jQuery('.main .col-main').css('padding-top', '50px');
        jQuery('.toolbar').hide();

    }
  var gridItems = [];
        var cnt = 0;
        
        
  
    jQuery('body.template-collection ul.grid li.grid__item').each(function () {
        var productItem = this;
        var sku = jQuery(this).find('.product-sku').first().text();
        var tags = jQuery(this).find('.product-tags').first().text();

       if(tags.indexOf('ebike_rated') >= 0) {
         jQuery(productItem).find('.grid-view-item').first().append('<img class="ebike" src="http://yakimaassets.s3.us-west-2.amazonaws.com/BikeRated.png"/>');
       }

        var url = yakimaApiUrl + '/fitcheck/GetFitCheck/' + fitId + '/' + sku + '/' + vehicleId + '/' + rooftypeId;
        console.log(url);
        jQuery.get(url, function (data) {
            jQuery(productItem).find('.product-fit').html();
            productFit = data > 0;
            if (productFit) {
                jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot fit">•</span>Compatible</span></span>');

            }
            else if (fitId == -4) {
                 jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot unknown">•</span>Can\'t confirm fit</span></span>');

            }
            else if (data == 0) {
                 jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot nofit">•</span>Not Compatible</span></span>');
                if(towerCat)
                    jQuery('#category-nofit ul.grid').append(jQuery(productItem).detach().addClass('widescreen--one-third'));

            }
            else if (data == -3) {
                 jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot unknown">•</span>Confirm Hitch Dimensions</span></span>');
            }
            else if (data == -5) {
                 jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot unknown">•</span>Can\'t confirm compatibility</span></span>');
            }
            else if (data == -2) {
                if (document.getElementById('fitCurrentVehicle')) {
                    document.getElementById('fitCurrentVehicle').innerHTML = '';
                }
            }
            else if (data == -1) {
                if (vehicleId && vehicleId.length > 0 && fitId == '0')
                     jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot unknown">•</span>System Required</span></span>');
                else
                     jQuery(productItem).addClass('msg').find('.grid-view-item').first().append('<span class="product-fit"><span class="text"><span class="dot unknown">•</span>Vehicle Info Needed</span></span>');
            }
          

        });

          
    });
    
 // }, 2500);
}

function fmcPage() {
    var vmId = localStorage.getItem('vehicleMarketId');
    var rooftypeId = localStorage.getItem('rooftypeId');
  var lang = market;
  
  if(lang == 'dk' || lang == 'be') lang = 'nl';
  if(lang == 'cz') lang = 'cs';
  if(lang == 'se') lang = 'sv';

  
        var url = yakimaApiUrl + '/system/GetSystems/' + vmId + '/' + rooftypeId + '/' + lang;

  //  if(model) model = model.replaceAll('/', '~');
    //    var url = yakimaApiUrl + '/system/GetSystems/6/' + year + '/' + makeId + '/' + encodeURIComponent(model.replaceAll(' ', '')) + '/' + type + '/' + rooftypeId + '/' + lang;
    console.log(url);
    

          jQuery('#fmc-page #rack-systems').html('<div id="fit-filters"></div>');
    jQuery.get(url, function (data) {
      console.log(data);
            jQuery.each(data, function (i, e) {
              var system = '';
              const streamline = [32,38,33,43,34,39,41,42];
              const slmarkets = ['en','uk','de','at', 'ch'];
             
              if(streamline.includes(e.fitTypeId) && !slmarkets.includes(market))
              {
                console.log('hiding Streamline fit', e.fitTypeId, market);
                // StreamLine fits only show for UK, Germany, Austria and Switzerland
              }
              else {
                if(e.fitTypeId != 46)
                   system = GetSystemHtml(false, e.fitId, e.fitTypeId, e.mountType, e.fitImage, e.platformSku, e.minBarLength,  e.barSizeFront, e.barSizeRear, e.loadRating, e.components, e.comments);
                if(e.fitTypeId == 42) {
           //       system += GetSystemHtml(false, e.fitId, 942, e.mountType, e.fitImage, e.platformSku, e.minBarLength, e.barSizeFront, e.barSizeRear, e.loadRating, e.components, e.comments);
                }
                if(e.fitTypeId == 45) {
                //  system += GetSystemHtml(945, e.PlatformSku, e.MinBarLength, e.BarSizeFront, e.BarSizeRear, e.LoadRating, e.Components);
                }
               jQuery('#fmc-page #rack-systems').append(system);
              }
            });
           addFilters();
    });
    
    
}
function fmcDetailPage() {
  
  var year = localStorage.getItem('year');
    var makeId = localStorage.getItem('makeId');
    var model = localStorage.getItem('model-name');
    var type = localStorage.getItem('vehicle-type');
    var rooftypeId = localStorage.getItem('rooftypeId');
    var vmId = localStorage.getItem('vehicleMarketId');

    model = model.replaceAll('/', '~');
  var lang = market;
  if(lang == 'dk' || lang == 'be') lang = 'nl';
  if(lang == 'dk') lang = 'nl';
  if(lang == 'cz') lang = 'cs';
  if(lang == 'se') lang = 'sv';
  if(lang == 'uk') lang = 'en';
        var url = yakimaApiUrl + '/system/GetSystems/' + vmId + '/' + rooftypeId + '/' + lang;
    const urlParams = new URLSearchParams(window.location.search);
    var fitId = urlParams.get('fitId');

        var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
      jQuery('#fmc-page #vehicle-title').html(vehName);
  
    console.log(url);
    
          jQuery('#fmc-page #rack-systems').html('');
    jQuery.get(url, function (data) {
      console.log(data);
            jQuery.each(data, function (i, e) {
              if(e.fitId == fitId) {
                var system = GetSystemHtml(true, e.fitId, e.fitTypeId, e.mountType, e.fitImage, e.platformSku, e.minBarLength, e.barSizeFront, e.barSizeRear, e.loadRating, e.components, e.comments);
               jQuery('#fmc-page #rack-systems').append(system);
                 var url2 = yakimaApiUrl + '/system/GetSystem/' + fitId + '/6/' + lang;
                console.log(url2);
                 jQuery.get(url2, function (data2) {
                  if (typeof data2 == 'object') {
                    console.log(data2);
                    if(data2.features != null) {
                       jQuery('#fmc-page #rack-systems').append("<h2>Features</h2>");
                       jQuery('#fmc-page #rack-systems').append(data2.features);
                       jQuery('#fmc-page #rack-systems').append("<br/><br/><h2>Installation</h2>");
                      if(data2.installation != null) {
                       jQuery('#fmc-page #rack-systems').append("<p>" + data2.installation + "</p>");
                      }
                      if(data2.towerSku != null && data2.towerSku.length > 0) {
                       jQuery('#fmc-page #rack-systems').append("<a href='https://assets.yakima.com/product/instructions/" + data2.towerSku + "'>" + data2.towerSku + " Instructions</a><br/>");
                      }
                       if(data2.fitKitSku != null && data2.fitKitSku.length > 0) {
                       jQuery('#fmc-page #rack-systems').append("<a href='https://assets.yakima.com/product/instructions/" + data2.fitKitSku + "'>" + data2.fitKitSku + " Instructions</a>");
                      }
                      
                       jQuery('#fmc-page #rack-systems').append("<p><br/><a href='https://pit-eu.yakima.com?fitid=" + data2.fitId + "'>Installation Settings</a></p>");
                    }
                    
                    if(e.fitTypeId <= 45 || e.fitTypeId == 59) {
                      var installation = GetInstallationMeasurements(data2.m1, data2.m2, data2.m3, data2.m4, data2.p1, data2.p2, data2.fiClip, data2.foClip, data2.riClip, data2.roClip);
                      jQuery('#fmc-page #rack-systems').append(installation);
                    }
                  }
                });
              }
            });
    });
  
     
    
}


function GetInstallationMeasurements(m1, m2, m3, m4, p1, p2, fiClip, foClip, riClip, roClip) {
  var installation = '';
    installation += '<div id="components"><div class="section"><h2>Installation Measurements</h2>';
    installation += '<div class="left"><div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/m1_icon.png"/></div>';
    installation += '<div class="box-desc"><strong>Front Crossbar</strong><span class="caption">Inner edge of driver’s side leg to inner edge of passenger’s side leg </span></div>';
    installation += '<div class="box-val"><span class=""><strong>' + m1 + ' mm</strong></span></div></div>';

    installation += '<div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/m2_icon.png"/></div>';
    installation += '<div class="box-desc"><strong>Front Crossbar</strong><span class="caption">Corner of painted or glass roof to leading edge of front pad or foot</span></div>';
    installation += '<div class="box-val"><span class=""><strong>' + m2 + ' mm</strong></span></div></div> </div>';
    
    installation += '<div class="right">';

    installation += '<div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/m3_icon.png"/></div>';
    installation += '<div class="box-desc"><strong>Rear Crossbar</strong><span class="caption">Inner edge of driver’s side leg to inner edge of passenger’s side leg</span></div>';
    installation += '<div class="box-val"><strong>' + m3 + ' mm</strong></div></div>';

    installation += '<div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/m4_icon.png"/> </div>';
    installation += '<div class="box-desc"><strong>Crossbar Spread</strong><span class="caption">Rear edge of front crossbar to rear edge of rear crossbar.</span></div>';
    installation += '<div class="box-val"><strong>' + m4 + ' mm</strong></div></div></div>';

    installation += '<div class="diagram"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/measurements_diagram.png"/>  </div></div>';
            
    if(p1 != '') {
      installation += '<div class="section"><h2>PITCH SETTINGS</h2>';
      installation += '<div class="left"><div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/p1_icon.png"/></div>';
      installation += '<div class="box-desc"><span class=""><strong>Pitch 1</strong></span><span class="caption">Adjustment on the front legs to help keep the crossbars level</span></div>';
      installation += '<div class="box-val"><span class=""><strong>' + p1 + '</strong></span></div></div> </div>';
      
      installation += '<div class="right"><div class="box-container"><div class="box-logo"><span class="sub2"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/p2_icon.png"/></span></div>';
      installation += '<div class="box-desc"><strong>Pitch 2</strong><span class="caption">Adjustment on the rear legs to help keep the crossbars level</span></div>';
      installation += '<div class="box-val"><strong>' + p2 + '</strong> </div></div></div>';

      installation += '<div class="diagram"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/pitch_diagram.png"/> </div></div>';
    }

    if(fiClip != '') {
      installation += '<div class="section"><h2>(SC68) SIGHT CLIP DETAILS </h2>';

      installation += '<div class="left"><div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/front_outer-sightlip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Front Inner Clip</strong><span class="caption">Number imprinted on inner clip to be used on front bar</span></div><div class="box-val"><strong>R' + fiClip + '</strong></div></div>';

      installation += '<div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/front_outer-sightlip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Front Outer Clip</strong><span class="caption">Number imprinted on outer clip to be used on front bar</span></div><div class="box-val"><strong>R' + foClip + '</strong></div></div></div>';        


      installation += '<div class="right"><div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/front_outer-sightlip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Rear Inner Clip</strong><span class="caption">Number imprinted on inner clip to be used on rear bar</span></div><div class="box-val"><strong>R' + riClip + '</strong></div></div>';

      installation += '<div class="box-container"><div class="box-logo"><img src="http://d2amiavn18tu8z.cloudfront.net/fmc/front_outer-sightlip_icon.png"></div>';
      installation += '<div class="box-desc"><strong>Rear Outer Clip</strong><span class="caption">Number imprinted on outer clip to be used on rear bar</span></div><div class="box-val"><strong>R' + roClip + '</strong></div></div></div>';  
        installation += '<div class="diagram"></div></div>';
    }
    installation += '</div>';
    return installation;
}
function GetSystemHtml(detailPage, fitId, fitTypeId, roofTypeId, fitImage, platformSku, minBarLength, barSizeFront, barSizeRear, loadRating, components, comment) {
    var systemPrice = 0;
      var mountType = 'Clamp Mount';
      var towerName = towerName + ' Legs Pack of 4';
      var towerSku = '';
      var towerPrice = 0;
      var systemImg = '';
      var systemImg2 = '';
      var barCount = 2;
      var fitClass = "";
  var barType = "";

  
       if(fitTypeId == 14) { towerName = 'Truck System'; fitClass = 'truck'; }
        if(fitTypeId == 55) { towerName = 'LockNLoad'; fitClass = 'lnl'; }
        if(fitTypeId == 37 || fitTypeId == 49) { towerName = 'RailBar'; fitClass = 'aero crossbar'; }
        if(fitTypeId == 47 || fitTypeId == 62) { towerName = 'Aero ThruBar'; fitClass = 'aero crossbar'; }
        if(fitTypeId == 36) { towerName = 'FlushBar Mount'; fitClass = 'aero crossbar'; }
        if(fitTypeId == 38) { towerName = 'BaseLine FX Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 32) { towerName = 'BaseLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 33) { towerName = 'TimberLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 43) { towerName = 'TimberLine FX Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 34) { towerName = 'SkyLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 39) { towerName = 'SkyLine FX Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 42) { towerName = 'SightLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 41) { towerName = 'SightLine FX Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 45) { towerName = 'RibCage Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 59) { towerName = 'TrimHD Mount'; fitClass = 'trim crossbar'; }
        if(fitTypeId == 942) { towerName = 'SightLine Mount'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId == 945) { towerName = 'Yakima SmartFoot'; fitClass = 'jetstream crossbar'; }
        if(fitTypeId >= 63 && fitTypeId <= 68) { 
          towerName = 'Yakima SmartFoot'; 
          fitClass = 'aero crossbar'; 
        }

  

      systemImg = towerName.toLowerCase().replace(' mount', '').replace(' ', '-') + '-close.png';

      if(fitTypeId == 942) systemImg = 'trimhd-close.png';
      var isRuggedLine = false;
  
      var platformName = '';
      var towerSku = '';
      var barType = 'JetStream';
      var towerCnt = 0;
      for(i=0;i<components.length;i++) {
          if(components[i].roleId == 1) towerSku = components[i].sku;
          if(components[i].roleId == 6 && components[i].sku != '9812105') { 
            barType = components[i].name.substring(0, components[i].name.indexOf(' Bar'));
            if(components[i].name.indexOf('ThruBar') >= 0)
              barType = 'ThruBar';
            systemImg2 = barType.toLowerCase() + '-2bar.png';
          }
          if(fitTypeId >= 63 && fitTypeId <= 68 && (components[i].roleId == 6 || components[i].roleId == 1)) {
            if(components[i].name.toLowerCase().indexOf('flushbar') >= 0) { platformName = 'Aero FlushBar';  systemImg = 'aero-flushbar-main.png'; systemImg2 = 'aero-flushbar-alt.png'; }
            if(components[i].name.toLowerCase().indexOf('thrubar') >= 0) { platformName = 'Aero ThruBar'; systemImg = 'aero-thrubar-main.png'; systemImg2 = 'aero-thrubar-alt.png'; }
            if(components[i].name.toLowerCase().indexOf('railbar') >= 0) { platformName = 'Aero RailBar';  systemImg = 'aero-railbar-main.png';systemImg2 = 'aero-railbar-alt.png'; }
          }
          if(components[i].sku == '9813044') {towerName = 'SIGHTLINE MOUNT'; systemImg = 'sightline-close.png';   }
          if(components[i].sku == '9813004') {towerName = 'BASELINE MOUNT'; systemImg = 'baseline-close.png';  }
          if(components[i].sku == '9813064') {towerName = 'TIMBERLINE MOUNT'; systemImg = 'timberline-close.png';  }
          if(components[i].sku == '9813024' || components[i].sku == '9813022') {towerName = 'SKYLINE MOUNT';  systemImg = 'skyline-close.png'; }
          if(components[i].sku == '9812105') {towerName = 'Yakima SmartFoot'; fitClass = 'trim crossbar'; systemImg = 'hdlegkit-close.png';  }
          if(components[i].sku == '8000350') {towerName = 'Gutter Mount'; systemImg = 'lnl-guttermount.png';  }
          if(components[i].sku == '8000351') {towerName = 'Gutter Mount'; systemImg = 'guttermount-close.png';  }
          if(components[i].sku == '9812179') { systemImg = 'ruggedline7-close.png';  }
          if(components[i].sku == '8000144') { systemImg = 'tracklegsmk1-lnl-close.png';  }
          if(components[i].sku == '9800304' || components[i].sku == '9800306' || components[i].sku == '8000199') { systemImg = 'tracklegsmk1-trimhd-close.png';  }
          if(components[i].sku == '8001160') { systemImg = 'bedrock-close.png'; towerName = 'BEDROCK LEGS'; }
          if(components[i].sku == '8001152') { systemImg = 'outpost-close.png'; towerName = 'OUTPOST LEGS'; }
          if(components[i].sku == '8001151') { systemImg = 'overhaul-close.png'; towerName = 'OVERHAUL LEGS'; }
        

        if(components[i].name != null) {
            if(components[i].name.indexOf('HD Bar') >= 0 && components[i].sku.indexOf('800115') >= 0) { barType = 'HD';    }     
          if(components[i].name.indexOf('JetStream') >= 0) { barType = 'JetStream'; }     
          if(components[i].name.indexOf('RuggedLine') >= 0) { isRuggedLine = true; }     
        } 
        if(components[i].roleId == 1 || components[i].roleId == 2 || components[i].roleId == 15) towerCnt = towerCnt + components[i].quantity;
        if(components[i].roleId == 6 && components[i].name.toLowerCase().indexOf('platform') >= 0) {
            
            if(systemImg.indexOf('skyline-close') >= 0)
                systemImg = 'lnl-skyline.png'; 
            else if(systemImg.indexOf('timberline-close') >= 0)
                systemImg = 'lnl-timberline.png'; 
            else if(systemImg.indexOf('line-close') > 0 && systemImg.indexOf('ruggedline') < 0)
                systemImg = 'lnl-streamline.png';
            systemImg2 = 'lnl-' + components[i].sku.substring(4, 7) + '.png'; 
        }
     }
     if(systemImg2.indexOf('trimhd') >= 0 && systemImg.indexOf('line-close') >= 0)
        systemImg = systemImg.replace('line-close', 'line-trimhd-close');
     if(towerCnt > 2) barCount = towerCnt;
    if(platformName.length == 0)
      platformName = barType + ' CROSSBAR WITH ' + towerName.replace(' (Towers Only)', '');
  
  
    jQuery("#page-title").html(towerName);
  //   if(fitImage != null && fitImage.length > 0)
     //   systemImg = fitImage;

     if(fitTypeId == 55 || fitTypeId == 47)  {
        platformName = 'LockNLoad Platform';
        if(isRuggedLine) platformName += ' + RUGGEDLINE®';
      }
      if(fitTypeId == 36) { platformName = 'Aero FlushBar'; }
      if(fitTypeId == 62) { platformName = 'Aero ThruBar'; }
      if(fitTypeId == 49) { platformName = 'Aero RailBar'; }
      if(fitTypeId == 46) {  system = '';   }
        
      var system = '<div class="row ' + fitClass + '"><div class="col-sm-6 col-lg-4 image"><img src="https://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/' + systemImg + '">';
      if(systemImg.indexOf('-main') > 0 && systemImg2 != '') {
        systemImg2 = systemImg.replace('-main', '-alt');
      }
      system += '<img src="https://yakweb-au.s3.ap-southeast-2.amazonaws.com/fmc/' + systemImg2 + '">';
      system += '</div>';
      system += '<div class="details"><h2>' + platformName + '</h2><h5 class="mb-4 mb-lg-5">' + localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name') + '</h5>';
  
  
      //TRUCKBED
      if(fitTypeId == 14) { 
          
          mountType = 'TruckBed Mount';
          towerSku = towerSku;
          towerPrice = towerPrice;
          towerName = towerName.replace('(Towers Only)', '');
          systemPrice += towerPrice;
      }
      //BASELINE
      if(fitTypeId == 32 || fitTypeId == 38) { 
         
          towerSku = fitTypeId == 32 ? '9813004' : '9813014';
          towerPrice = 239;
          systemPrice += towerPrice;
      }
      //SKYLINE
      if(fitTypeId == 34 || fitTypeId == 39) { 
         
          mountType = 'Rail Mount';
          towerSku = fitTypeId == 34 ? '9813024' : '9813034';
        
      }
      
      
    console.log('components', components);
      var systemWeight = 0;
      for(i=0;i<components.length;i++) {
       
        if(components[i].roleId == 7) {
          // Ignore Windshields
        }
        else {
          if(components[i].name.indexOf('TrimHD') >= 0 && components[i].quantity == 1) components[i].quantity = towerCnt;
          var price = components[i].price * components[i].quantity + '.00';
          if(components[i].price % 1 > 0) 
            price = components[i].price + '0';
         system += '<dl><dt><span class="bar-label">+ ' + components[i].name + ' x ' + components[i].quantity;

         system += '</span><br>';
         system += '<span class="bar-sku bar-sku-highlight"><small>SKU: ' + components[i].sku + '</small></span>';
         system += getAltBar(components[i].sku);
        
        system += '</dt>';
      //   system += '<dd class="price-col">$' + price + '</dd></dl>';
         systemPrice += components[i].price * components[i].quantity;
         systemWeight += (components[i].weight * components[i].quantity) * 0.453592;
       }
      }
  
      if(roofTypeId == 1) {
          mountType = 'Clamp Mount';
      }
      if(roofTypeId == 3) {
          mountType = 'Track Mount';
      }
      if(roofTypeId == 4) {
          mountType = 'Rail Mount';
      }
      if(roofTypeId == 12) {
          mountType = 'Flush Rail Mount';
      }
      if(roofTypeId == 14) {
          mountType = 'Fixed Point Mount';
      }
     if(roofTypeId == 17) {
          mountType = 'Flush Rail/Fixed Point';
      }
  if(comment.indexOf('roof gutter') >= 0 || comment.indexOf('gouttière de toit') >= 0 || comment.indexOf('canalón de techo') >= 0 || comment.indexOf('Dachrinne') >= 0 || comment.indexOf('grondaia') >= 0 || comment.indexOf('střešní žlab') >= 0 || comment.indexOf('dakgoot') >= 0 || comment.indexOf('takrenne') >= 0 || comment.indexOf('rynna dachowa') >= 0 || comment.indexOf('strešný odkvap') >= 0 || comment.indexOf('takrännan') >= 0)
          mountType = 'Gutter Mount';

    var findDealer = 'Find a Dealer';
    var mountTypeLabel = 'Mount Type';
    var ratingLabel = 'Product Load Rating';
  
    var warning = 'Please refer to the vehicle manufacturer specifications for max load capacity of vehicle. The lowest load rating applies. Reductions may apply off road. <a href="/pages/roof-rack-load-ratings-explained" target="_blank" style="color: #ab2328;">Learn more.</a>';
    var comments = 'Comments';
    var learnMore = 'Learn More';
    var barSystem = 'Bar System';
  
    if(market == 'fr') {
      findDealer = 'Trouvez un revendeur';
      mountTypeLabel = 'Type de montage';
      ratingLabel = 'Charge nominale du produit';
      comments = 'Commentaires';
      learnMore = 'En savoir plus';
      barSystem = 'Système de bar';
      warning = "Veuillez vous référer aux spécifications du constructeur du véhicule pour connaître la capacité de charge maximale du véhicule. La capacité de charge la plus basse s'applique. Des réductions peuvent s'appliquer hors route.  <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>En savoir plus.</a>";
    }
    if(market == 'es') {
      findDealer = "Encuentre un concesionario";
      mountTypeLabel = "Tipo de montaje";
      ratingLabel = "Clasificación de carga del producto";
      comments = "Comentarios";
      learnMore = "Obtenga más información";
      barSystem = "Sistema de barras";
      warning = "Consulte las especificaciones del fabricante del vehículo para conocer la capacidad máxima de carga del vehículo. Se aplica la capacidad de carga más baja. Se pueden aplicar reducciones fuera de la carretera. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Obtenga más información.</a>";

    }
    if(market == 'de') {
      findDealer = "Finden Sie einen Händler";
      mountTypeLabel = "Art der Halterung";
      ratingLabel = "Tragfähigkeit des Produkts";
      comments = "Kommentare";
      learnMore = "Erfahre mehr";
      barSystem = "Barsystem";
      warning = "Die maximale Ladekapazität des Fahrzeugs entnehmen Sie bitte den Angaben des Fahrzeugherstellers. Es gilt die niedrigste Tragfähigkeit. Ermäßigungen können abseits der Straße gelten. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Erfahren Sie mehr.</a>";

    }
  if(market == 'it') {
    findDealer = "Trova un rivenditore";
      mountType = "Tipo di montaggio";
      ratingLabel = "Valutazione del carico del prodotto";
      comments = "Commenti";
      learnMore = "Scopri di più";
      barSystem = "Sistema a barre";
      warning = "Si prega di fare riferimento alle specifiche del produttore del veicolo per la capacità di carico massima del veicolo. Si applica il coefficiente di carico più basso. Le riduzioni possono essere applicate in fuoristrada. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Scopri di più.</a>";

    }
  if(market == 'cz') {
    findDealer = "Najít prodejce";
      mountTypeLabel = "Typ montáže";
      ratingLabel = "Hodnocení zatížení produktu";
      comments = "Komentář";
      learnMore = "Dozvědět se více";
      barSystem = "Barový systém";
      warning = "Maximální nosnost vozidla naleznete ve specifikacích výrobce vozidla. Platí nejnižší zatížitelnost. Snížení může platit mimo silnici. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Dozvědět se více.</a>";

  }
  if(market == 'dk' || market == 'be') {
      findDealer = "Vind een dealer";
      mountTypeLabel = "Soort montage";
      ratingLabel = "Beoordeling van de belasting van het product";
      comments = "Commentaren";
      learnMore = "Meer informatie";
      barSystem = "Bar-systeem";
      warning = "Raadpleeg de specificaties van de voertuigfabrikant voor het maximale laadvermogen van het voertuig. De laagste belastingsclassificatie is van toepassing. Er kunnen kortingen van toepassing zijn op het terrein. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Meer informatie.</a>";

    }
  if(market == 'no') {
      findDealer = "Finn en forhandler";
      mountTypeLabel = "Monteringstype";
      ratingLabel = "Produktbelastningsvurdering";
      comments = "Kommentarer";
      learnMore = "Mer informasjon";
      barSystem = "Barsystem";
      warning = "Se kjøretøyprodusentens spesifikasjoner for maksimal lastekapasitet på kjøretøyet. Den laveste belastningsvurderingen gjelder. Reduksjoner kan gjelde utenfor veien. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Mer informasjon.</a>";
    }
  if(market == 'pl') {
      findDealer = "Znajdź dealera";
      mountTypeLabel = "Typ mocowania";
      ratingLabel = "Ocena obciążenia produktu";
      comments = "Komentarze";
      learnMore = "Dowiedz się więcej";
      barSystem = "System prętów";
      warning = "Aby uzyskać maksymalną ładowność pojazdu, zapoznaj się ze specyfikacjami producenta pojazdu. Obowiązuje najniższa wartość obciążenia. Obniżki mogą obowiązywać poza drogami. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Dowiedz się więcej.</a>";

    }
  if(market == 'sk') {
      findDealer = "Nájdite predajcu";
      mountTypeLabel = "Typ montáže";
      ratingLabel = "Hodnotenie zaťaženia produktu";
      comments = "Komentáre";
      learnMore = "Prečítajte si viac";
      barSystem = "Barový systém";
      warning = "Pre maximálnu nosnosť vozidla si pozrite špecifikácie výrobcu vozidla. Platí najnižšia hodnota zaťaženia. Zníženia sa môžu vzťahovať aj mimo cesty. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Dozvedieť sa viac.</a>";

    }
  if(market == 'se') {
      findDealer = "Hitta en återförsäljare";
      mountTypeLabel = "Monteringstyp";
      ratingLabel = "Produktbelastningsbetyg";
      comments = "Kommentarer";
      learnMore = "Läs mer";
      barSystem = "Barsystem";
      warning = "Se fordonstillverkarens specifikationer för fordonets maximala lastkapacitet. Den lägsta belastningsklassificeringen gäller. Minskningar kan gälla utanför vägen. <a href='/pages/roof-rack-load-ratings-explained' target='_blank' style='color: #ab2328;'>Läs mer.</a>";

    }
   
      system += '<dl class="half"><dt>' + mountTypeLabel + ':</dt><dd>' + mountType + '</dd></dl>';
      system += '<dl class="half"><dt>' + ratingLabel + ': </dt><dd>' + loadRating + ' kg</dd></dl>';
      system += '<dl style="font-size: 13px; font-weight: 200;">' + warning + '</dl>';
      system += '<dl class="half"><dt>' + comments + ':</dt></dl><dl style="font-size: 13px; font-weight: 200;"><p id="fitComments">' + comment +'</p><p>Note: ' + barCount + ' ' + barSystem + '</p></dl>';

        if(detailPage) {
          system += '<a href="/pages/dealer-locator" class="find-dealer btn">' + findDealer + '</a></div>';
        }
      system += '</div>';
      
      var priceText = systemPrice + '.00';
      if(systemPrice % 1 > 0) 
        priceText = systemPrice + '0';
    //  system += '<div class="more-info"><div class="price-col price">$' + priceText + '</div><div class="font-size-sm">(RRP includes GST and excludes any applicable third-party freight or installation fees)</div>';
        if(!detailPage) {
          system += '<div class="more-info">';
          system += '<a href="/pages/fit-detail?fitId=' + fitId + '" class="btn learn-more">' + learnMore + '</a><a href="/find-a-dealer" class="find-dealer btn">' + findDealer + '</a></div></div>';
        }
      

     return system;
}
function getAltBar(sku) {
    var isku = parseInt(sku);
    var altSku = 0;
    if(isku >= 9813700 && isku <= 9813706) altSku = isku + 7;
    if(isku >= 9813500 && isku <= 9813504) altSku = isku + 5;
    if(isku >= 8050227 && isku <= 8050230) altSku = isku - 40;
    if(isku >= 9813500 && isku <= 9813504) altSku = isku + 5;
    if(isku >= 8050217 && isku <= 8050226) altSku = isku - 40;
    if(isku >= 8050238 && isku <= 8050246) altSku = isku - 37;

    //Flushbar 
    if(isku == 8050232) altSku = 8050191;
    if(isku == 8050233) altSku = 8050193;
    if(isku == 8050234) altSku = 8050194;
    if(isku == 8050235) altSku = 8050196;
    if(isku == 8050236) altSku = 8050197;
    if(isku == 8050237) altSku = 8050198;
    if(isku == 8050238) altSku = 8050199;

    if(altSku > 0)
        return '<br><span class="bar-sku bar-sku-highlight"><small>Also available in silver (SKU: ' + altSku.toString() + ')</small></span>';
    else 
        return '';
}
function addFilters() {
   var totalCnt = jQuery('#rack-systems .row').length;
   var lnlCnt = jQuery('#rack-systems .row.lnl').length;
   var truckCnt = jQuery('#rack-systems .row.truck').length;
   var crossbarCnt = jQuery('#rack-systems .row.crossbar').length;
   var jsCnt = jQuery('#rack-systems .row.jetstream').length;
   var trimCnt = jQuery('#rack-systems .row.trim').length;
   var aeroCnt = jQuery('#rack-systems .row.aero').length;
  var filter = '';

  var carryWhere = 'Choose your preferred carrying solution';
    var platformLabel = 'Platform';
    var platformDesc = 'Super tough and super strong.  Designed from the ground up for the ultimate 4x4, touring and commercial solution.';
    var crossbarLabel = 'Crossbars';
    var crossbarDesc = 'Secure your load with a set of crossbars from our extensive range.';
    var truckbedLabel = 'Truck Bed';
    var truckbedDesc = 'Carry your gear in the bed of your truck';
    var jetstreamDesc = 'Exceptionally aerodynamic, incredibly strong, lightweight and quiet on the move. Part of the StreamLine range - Yakima\'s newest and best ever roof rack system.';
    var trimDesc = 'Designed for heavier loads, TrimHD crossbars are ideal for 4x4 and commercial setups. Great for vans, utes, trucks and SUVs.';
    var aeroDesc = 'Our classic and original aerodynamic crossbars. Engineered to deliver superior performance with the least possible wind noise, drag, and vibration.';
  
    if(market == 'fr') {
      carryWhere = 'Choisissez votre solution de transport préférée';
      platformLabel = 'Plateforme';
      platformDesc = 'Super résistant et super solide. Conçu dès le départ pour la solution 4x4, touristique et commerciale ultime.';
      crossbarLabel = 'Barres transversales';
      crossbarDesc = 'Sécurisez votre chargement à l\'aide d\'un ensemble de barres transversales de notre vaste gamme.';
      truckbedLabel = 'Lit de camion';
      truckbedDesc = 'Transportez votre équipement dans la caisse de votre camion';
      jetstreamDesc = 'Exceptionnellement aérodynamique, incroyablement solide, léger et silencieux en mouvement. Fait partie de la gamme StreamLine, le système de barres de toit le plus récent et le meilleur jamais conçu par Yakima.';
      trimDesc = 'Conçues pour les charges plus lourdes, les barres transversales TrimHD sont idéales pour les configurations 4x4 et commerciales. Idéal pour les fourgonnettes, les véhicules utilitaires, les camions et les VUS.';
      aeroDesc = 'Nos barres transversales aérodynamiques classiques et originales. Conçu pour offrir des performances supérieures avec le moins possible de bruit du vent, de traînée et de vibrations.';    
    }
    if(market == 'es') {
      carryWhere = 'Elija la solución de transporte que prefiera';
      platformLabel = 'Plataforma';
      platformDesc = 'Súper resistente y superfuerte. Diseñado desde cero para ofrecer la mejor solución comercial, de turismo y de 4x4.';
      crossbarLabel = 'Barras transversales';
      crossbarDesc = 'Asegure su carga con un juego de barras transversales de nuestra amplia gama.';
      truckbedLabel = 'Cama de camión';
      truckbedDesc = 'Lleve su equipo en la caja de su camioneta';
      jetstreamDesc = 'Excepcionalmente aerodinámicos, increíblemente fuertes, ligeros y silenciosos mientras te mueves. Parte de la gama StreamLine: el mejor y más nuevo sistema de portaequipajes de techo de Yakima.';
      trimDesc = 'Diseñados para cargas más pesadas, los travesaños TrimHD son ideales para configuraciones comerciales y de vehículos todo terreno. Ideal para furgonetas, utes, camiones y vehículos deportivos utilitarios.';
      aeroDesc = 'Nuestros travesaños aerodinámicos clásicos y originales. Diseñados para ofrecer un rendimiento superior con el mínimo ruido del viento, resistencia y vibración posibles.';    

    }
    if(market == 'de') {
      carryWhere = 'Wählen Sie Ihre bevorzugte Tragelösung';
      platformLabel = 'Plattform';
      platformDesc = 'Super robust und superstark. Von Grund auf für die ultimative Allradfahrzeug-, Touren- und kommerzielle Lösung konzipiert.';
      crossbarLabel = 'Querstangen';
      crossbarDesc = 'Sichern Sie Ihre Ladung mit einem Satz Querstangen aus unserem umfangreichen Sortiment.';
      truckbedLabel = 'LKW-Ladefläche';
      truckbedDesc = 'Tragen Sie Ihre Ausrüstung auf der Ladefläche Ihres Trucks';
      jetstreamDesc = 'Außergewöhnlich aerodynamisch, unglaublich stark, leicht und leise unterwegs. Teil der StreamLine-Reihe — Yakimas neuestes und bestes Dachträgersystem aller Zeiten.';
      trimDesc = 'Die TrimHD-Querträger wurden für schwerere Lasten entwickelt und eignen sich ideal für Allradfahrzeuge und gewerbliche Anlagen. Ideal für Lieferwagen, Geländewagen, Lastwagen und SUVs.';
      aeroDesc = 'Unsere klassischen und originellen aerodynamischen Querträger. Entwickelt, um überragende Leistung bei möglichst geringen Windgeräuschen, Luftwiderstand und Vibrationen zu bieten.';    
    }
  if(market == 'it') {
      carryWhere = 'Scegli la tua soluzione di trasporto preferita';
      platformLabel = 'Piattaforma';
      platformDesc = 'Super resistente e super resistente. Progettato da zero per la soluzione 4x4 definitiva, da turismo e commerciale.';
      crossbarLabel = 'Traverse';
      crossbarDesc = 'Proteggi il tuo carico con un set di traverse della nostra vasta gamma.';
      truckbedLabel = 'Letto per camion';
      truckbedDesc = 'Trasporta la tua attrezzatura nel pianale del tuo camion';
      jetstreamDesc = 'Eccezionalmente aerodinamico, incredibilmente resistente, leggero e silenzioso in movimento. Parte della gamma StreamLine, il sistema portapacchi più nuovo e migliore di sempre di Yakima.';
      trimDesc = 'Progettate per carichi più pesanti, le barre trasversali TrimHD sono ideali per configurazioni 4x4 e commerciali. Ideale per furgoni, auto, camion e SUV.';
      aeroDesc = 'Le nostre traverse aerodinamiche classiche e originali. Progettate per offrire prestazioni superiori con il minor rumore possibile, resistenza e vibrazioni dovute al vento.';    
    }
  if(market == 'cz') {
      carryWhere = 'Vyberte si preferované řešení pro přenášení';
      platformLabel = 'Nástupiště';
      platformDesc = 'Super tvrdý a super silný. Navrženo od základů pro dokonalé 4x4, cestovní a komerční řešení.';
      crossbarLabel = 'Příčky';
      crossbarDesc = 'Zabezpečte svůj náklad sadou příček z naší široké nabídky.';
      truckbedLabel = 'Ložnice pro nákladní vozidla';
      truckbedDesc = 'Noste své vybavení v posteli svého kamionu';
      jetstreamDesc = 'Výjimečně aerodynamický, neuvěřitelně silný, lehký a tichý na cestách. Součást řady StreamLine - nejnovější a nejlepší systém střešních nosičů Yakima.';
      trimDesc = 'Příčky TrimHD jsou navrženy pro těžší zatížení a jsou ideální pro nastavení 4x4 a komerční instalace. Skvělé pro dodávky, auta, nákladní automobily a SUV.';
      aeroDesc = 'Naše klasické a originální aerodynamické příčky. Navrženo tak, aby poskytovalo vynikající výkon s minimálním možným hlukem větru, odporem a vibracemi.';    
  }
  if(market == 'dk' || market == 'be') {
      carryWhere = 'Kies de draagoplossing van uw voorkeur';
      platformLabel = 'Platform';
      platformDesc = 'Supersterk en supersterk. Vanaf het begin ontworpen voor de ultieme 4x4-, tour- en commerciële oplossing.';
      crossbarLabel = 'Dwarsbalken';
      crossbarDesc = 'Beveilig uw lading met een set dwarsbalken uit ons uitgebreide assortiment.';
      truckbedLabel = 'Vrachtwagenbed';
      truckbedDesc = 'Draag je spullen in de laadbak van je truck';
      jetstreamDesc = 'Uitzonderlijk aerodynamisch, ongelooflijk sterk, licht en stil onderweg. Onderdeel van het StreamLine-assortiment: Yakima\'s nieuwste en beste dakdragersysteem ooit.';
      trimDesc = 'TrimHD-dwarsbalken zijn ontworpen voor zwaardere ladingen en zijn ideaal voor 4x4-opstellingen en commerciële opstellingen. Geweldig voor bestelwagens, utes, vrachtwagens en SUV\'s.';
      aeroDesc = 'Onze klassieke en originele aerodynamische dwarsbalken. Ontworpen om superieure prestaties te leveren met zo min mogelijk windgeruis, luchtweerstand en trillingen.';    
    }
  if(market == 'no') {
      carryWhere = 'Velg din foretrukne bæreløsning';
      platformLabel = 'Plattform';
      platformDesc = 'Super tøff og supersterk. Designet fra grunnen av for den ultimate 4x4-, touring- og kommersielle løsningen.';
      crossbarLabel = 'Tverrstenger';
      crossbarDesc = 'Sikre lasten din med et sett med tverrstenger fra vårt omfattende utvalg.';
      truckbedLabel = 'Lastebilseng';
      truckbedDesc = 'Bær utstyret ditt i sengen på lastebilen';
      jetstreamDesc = 'Eksepsjonelt aerodynamisk, utrolig sterk, lett og stille på farten. En del av StreamLine serien - Yakimas nyeste og beste takstativsystem noensinne.';
      trimDesc = 'TrimHD tverrstenger er designet for tyngre belastninger og er ideelle for 4x4 og kommersielle oppsett. Flott for varebiler, uter, lastebiler og SUVer.';
      aeroDesc = 'Våre klassiske og originale aerodynamiske tverrstenger. Konstruert for å levere overlegen ytelse med minst mulig vindstøy, luftmotstand og vibrasjon.';    
  }
  if(market == 'pl') {
      carryWhere = 'Wybierz preferowane rozwiązanie do przenoszenia';
      platformLabel = 'Platforma';
      platformDesc = 'Super wytrzymały i super mocny. Zaprojektowany od podstaw dla najlepszego rozwiązania 4x4, turystycznego i komercyjnego.';
      crossbarLabel = 'Poprzeczki';
      crossbarDesc = 'Zabezpiecz swój ładunek za pomocą zestawu poprzeczek z naszej szerokiej gamy.';
      truckbedLabel = 'Łóżko ciężarówki';
      truckbedDesc = 'Noś swój sprzęt w łóżku ciężarówki';
      jetstreamDesc = 'Wyjątkowo aerodynamiczny, niesamowicie mocny, lekki i cichy w ruchu. Część asortymentu StreamLine - najnowszy i najlepszy w historii system bagażników dachowych Yakima.';
      trimDesc = 'Zaprojektowane z myślą o większych obciążeniach, poprzeczki TrimHD idealnie nadają się do układów 4x4 i komercyjnych. Idealne do samochodów dostawczych, aut, ciężarówek i SUV-ów.';
      aeroDesc = 'Nasze klasyczne i oryginalne poprzeczki aerodynamiczne. Zaprojektowany, aby zapewnić doskonałą wydajność przy możliwie najmniejszym hałasie wiatru, oporze i wibracji.';    
    }
  if(market == 'sk') {
      carryWhere = 'Vyberte si preferované riešenie pre prenášanie';
      platformLabel = 'Platforma';
      platformDesc = 'Super tvrdý a super silný. Navrhnuté od základov pre dokonalé riešenie 4x4, cestovné a komerčné.';
      crossbarLabel = 'Priečníky';
      crossbarDesc = 'Zaistite svoj náklad pomocou súpravy priečnikov z nášho rozsiahleho sortimentu.';
      truckbedLabel = 'Posteľ pre nákladné auto';
      truckbedDesc = 'Preneste svoje vybavenie v posteli vášho nákladného vozidla';
      jetstreamDesc = 'Výnimočne aerodynamický, neuveriteľne silný, ľahký a tichý na cestách. Súčasťou radu StreamLine - najnovší a najlepší strešný nosič spoločnosti Yakima.';
      trimDesc = 'Priečne lišty TrimHD sú navrhnuté pre väčšie zaťaženie a sú ideálne pre zariadenia 4x4 a komerčné zariadenia. Skvelé pre dodávky, vozidlá, nákladné vozidlá a SUV.';
      aeroDesc = 'Naše klasické a originálne aerodynamické priečky. Navrhnuté tak, aby poskytovalo vynikajúci výkon s najmenším možným hlukom vetra, odporom a vibráciami.';    
    }
  if(market == 'se') {
      carryWhere = 'Välj din föredragna bärlösning';
      platformLabel = 'Plattform';
      platformDesc = 'Super tuff och superstark. Designad från grunden för den ultimata 4x4-, touring- och kommersiella lösningen.';
      crossbarLabel = 'Tvärstänger';
      crossbarDesc = 'Säkra din last med en uppsättning tvärstänger från vårt omfattande sortiment.';
      truckbedLabel = 'Lastbilssäng';
      truckbedDesc = 'Bär din utrustning i sängen på din lastbil';
      jetstreamDesc = 'Exceptionellt aerodynamisk, otroligt stark, lätt och tyst på resande fot. Ingår i StreamLine sortimentet - Yakimas nyaste och bästa takräckessystem någonsin.';
      trimDesc = 'TrimHD tvärstänger är utformade för tyngre laster och är idealiska för 4x4 och kommersiella installationer. Perfekt för skåpbilar, uter, lastbilar och stadsjeepar.';
      aeroDesc = 'Våra klassiska och originella aerodynamiska tvärstänger. Konstruerad för att leverera överlägsen prestanda med minsta möjliga vindbrus, luftmotstånd och vibrationer.';    
    }
  
  if((lnlCnt > 0 && totalCnt > lnlCnt) || (truckCnt > 0 && totalCnt > truckCnt)) {
    filter = '<div class="fit-placement"><h1>' + carryWhere + '</h1>';
    if(lnlCnt > 0)
      filter += '<div class="fmc-filter half lnl" onclick="applyFilter(\'lnl\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-platform.jpg"><h3>' + platformLabel + '</h3><p>' + platformDesc + '</p></div>';
    filter += '<div class="fmc-filter half crossbar" onclick="applyFilter(\'crossbar\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-roofracks.jpg"><h3>' + crossbarLabel + '</h3><p>' + crossbarDesc + '</p></div>';
    if(truckCnt > 0)
        filter += '<div class="fmc-filter half truck" onclick="applyFilter(\'truck\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-truckbed.jpg"><h3>' + truckbedLabel + '</h3><p>' + truckbedDesc + '</p></div>';
    filter += '</div>';
    jQuery('#fit-filters').html(filter);
    jQuery('#rack-systems .row').hide();
  }
  if(crossbarCnt > 0 && ((jsCnt > 0 && jsCnt < crossbarCnt) || (trimCnt > 0 && trimCnt < crossbarCnt) || (aeroCnt > 0 && aeroCnt < crossbarCnt))) {
    filter += '<div class="fit-crossbars' + ((lnlCnt > 0 && totalCnt > lnlCnt) ? ' hide' : '') + '"><h1>' + crossbarLabel + '</h1>';
    if(jsCnt > 0)
      filter += '<div class="fmc-filter third jetstream" onclick="applyFilter(\'jetstream\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-jetstream.jpg"><h3>JetStream</h3><p>' + jetstreamDesc + '</p></div>';
    if(trimCnt > 0)
      filter += '<div class="fmc-filter third trim" onclick="applyFilter(\'trim\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-trimhd.jpg"><h3>TrimHD</h3><p>' + trimDesc + '</p></div>';
    if(aeroCnt > 0)
      filter += '<div class="fmc-filter third aero" onclick="applyFilter(\'aero\');"><img src="http://d2amiavn18tu8z.cloudfront.net/images/fit-aero.jpg"><h3>Aero</h3><p>' + aeroDesc + '</p></div>';
    filter += '</div>'
    
    jQuery('#fit-filters').html(filter);
    jQuery('#rack-systems .row').hide();
  }
  
  if(filter.length == 0)
    jQuery('#fit-filters').hide();
  
}
function applyFilter(cls) {
  jQuery('#rack-systems .row').hide();
  jQuery('#rack-systems .row.' + cls).show();
  
  
  
  if(cls == 'lnl' || cls == 'crossbar' || cls == 'truck') {
    if(cls == 'lnl' || cls == 'truck') jQuery('#fit-filters .fit-crossbars').addClass('hide');
    jQuery('#fit-filters .fit-placement').addClass('short');
    jQuery('#fit-filters .fit-placement .fmc-filter.selected').removeClass('selected');
    jQuery('#fit-filters .fit-placement .fmc-filter.' + cls).addClass('selected');
  }
  else {
    jQuery('#fit-filters .fit-crossbars').addClass('short');
    jQuery('#fit-filters .fit-crossbars .fmc-filter.selected').removeClass('selected');
    jQuery('#fit-filters .fit-crossbars .fmc-filter.' + cls).addClass('selected');
  }
  if(cls == 'crossbar') {
    jQuery('#fit-filters .fit-crossbars.hide').removeClass('hide');
  }
  else {
  }
  
}
function windshieldPage() {
    var fitId = localStorage.getItem('fitId');
    if (fitId && fitId.length > 0) {
        var url = yakimaApiUrl + '/component/GetComponents/US/' + fitId + '/true';

        console.log(url);
        jQuery.get(url, function (data) {
            console.log(data);

            jQuery.each(data, function (i, e) {
                var psku = e.sku;
                if (psku.indexOf('800501') == 0) {
                    jQuery('#product-options-wrapper .cs-options li.cs-selected').removeClass('cs-selected');
                    jQuery('#product-options-wrapper .cs-options li').each(function () {
                        var size = jQuery(this).find('span').first().text();
                        if (e.Name.indexOf(size) >= 0) {
                            jQuery(this).addClass('cs-selected').click();
                            jQuery('#product-options-wrapper .cs-select').removeClass('cs-active');
                        }
                    });
                }
            });
        });
    }
}

function cartPopup() {
    var fitId = localStorage.getItem('fitId');

    jQuery('.cart-items .cart-item').each(function () {
        var cartItem = this;
      var sku = jQuery(this).find('.list-view-item__sku p').first().text().replace('SKU: # ', '');

        var url = yakimaApiUrl + '/fitnote/GetFitNotes/' + fitId + '/' + sku;
        console.log(url);
        jQuery.get(url, function (data) {
            jQuery.each(data, function (i, e) {
                if(e.sKUFilter.indexOf('+') <= 0 && e.note != null) //Ignore the combined SKU filters, like the Roundbar warnings
                    jQuery(cartItem).find('.list-view-item__sku').append('<p style="color: #811a1e; clear: both;">* ' + e.note + '</p>');
            });
        });
        

    });
  
  
}
function callAjax(url, failCnt) {
    console.log(url);
    new Ajax.Request(url, {
        method: 'post',
        onFailure: function (response) {
            failCnt++;
            if (failCnt > 5)
                alert('Ajax call failed: ' + url);
            else
                callAjax(url, failCnt);
        }
    });
}
